import { getNestedObject, getApiUrl, RenderCmsComponent, CmsEditButton, CmsPage } from 'bloomreach-experience-react-sdk';
import { parse } from 'url';
import { QueryString, LocaleUtils, isString, getLocalizedValue, StringUtils, getLocalizedAttrValue } from '@grandvision/utils';
import { FacetId, useAlgoliaConfig, AlgoliaSearch, SearchPageHeader, ConnectedProductListing } from '@grandvision/search';
import { get } from 'jsonpointer';
import React__default, { createElement, useState, useCallback, useEffect, useMemo, PureComponent, Fragment, createContext, useContext, memo, useRef } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { getDisplayName, compose } from 'recompose';
import { MediaQuery, AccordionItem, Accordion, Button, Util, Carousel, IFrame, ContentTabs, RichTextArea, Breadcrumbs, NotificationBar as NotificationBar$1, Olapic as Olapic$1, ScrollUpButton, CartButton } from '@grandvision/common';
import { CommerceToolsApi } from '@grandvision/commercetools';
import { useIntl, withIntl, connect } from '@grandvision/state';
import { Banner, HighlightedContentItem, HighlightedContent, RichBanner, ContentBanner, PromotionBannersItem, CategoryLinksItem, CertificatesItem, PromotionBanners, CategoryLinks, Certificates, BlogCard, BlogHero, BlogList, ExclusiveBrandsItem, ExclusiveBrands, BrandListItem, BrandList as BrandList$1, BrandListGroup, Video, FaqItem, Faq as Faq$1, IconList as IconList$1, UspGroup, HeadTags, BlogDetailHeader, BlogIntro } from '@grandvision/content';
import { Article as Article$1, Container, Heading as Heading$1, Text } from '@grandvision/elements';
import { FlexLayout, CookieNotification, FooterLinks, Footer, Header, SiteNav, getLocaleSwitcherMenuLabel, getLocaleSwitcherData, PageLayout } from '@grandvision/layout';
import { FeaturedProducts, Helpers, ProductPromotions, RecentlyViewedProducts as RecentlyViewedProducts$1 } from '@grandvision/products';
import { BookAppointment } from '@grandvision/forms';
import Cookie from 'js-cookie';
import compose$1 from 'recompose/compose';
import { setUserObject, WebPage } from '@grandvision/analytics';
import { State, Utils, MyAccountMenu, Selectors, Actions } from '@grandvision/auth';
import classnames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function createMenu(configuration) {
    var _a, _b;
    var items = (_b = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.models) === null || _a === void 0 ? void 0 : _a.menu) === null || _b === void 0 ? void 0 : _b.siteMenuItems;
    if (!items || !items.length) {
        return [];
    }
    return mapToMenu(items);
}
function mapToMenu(items) {
    return items.map(function (item) {
        var menuItem = {
            label: item.name,
            link: item._links.site,
        };
        if (item.parameters && Object.keys(item.parameters).length > 0) {
            menuItem.parameters = item.parameters;
        }
        if (item.childMenuItems && item.childMenuItems.length > 0) {
            menuItem.childMenuItems = mapToMenu(item.childMenuItems);
        }
        return menuItem;
    });
}

var defaultOptions = { context: true, channel: true, isMultilingual: false, locale: '' };
function createCmsUrl(cmsUrls, options) {
    var mergedOptions = __assign(__assign({}, defaultOptions), options);
    if (!cmsUrls.hostname) {
        throw new Error('hostname is required.');
    }
    var url = (cmsUrls.scheme || 'https') + "://" + cmsUrls.hostname;
    if (cmsUrls.port) {
        url += ':' + cmsUrls.port;
    }
    if (mergedOptions.context && cmsUrls.contextPath) {
        url += '/' + cmsUrls.contextPath;
    }
    if (mergedOptions.channel && cmsUrls.channelPath) {
        url += '/' + cmsUrls.channelPath;
    }
    if (mergedOptions.isMultilingual && mergedOptions.locale) {
        url += '/' + mergedOptions.locale;
    }
    return url;
}
function createResourcesUrl(resourceIds, locale, urls) {
    if (locale === void 0) { locale = ''; }
    var _a = urls.live, scheme = _a.scheme, hostname = _a.hostname;
    var _b = urls.live, port = _b.port, contextPath = _b.contextPath, channelPath = _b.channelPath;
    var url = (scheme || 'https') + "://" + hostname;
    if (port) {
        url += ':' + port;
    }
    if (contextPath) {
        url += '/' + contextPath;
    }
    url += '/api/resources';
    if (locale) {
        url += '/' + locale;
    }
    if (channelPath) {
        url += '/' + channelPath;
    }
    return url + "?resourceBundleIds=" + encodeURIComponent(resourceIds.join(','));
}

/**
 * Converts default JSON structure of bloomreach resource API to flat format:
 * { [key: string (e.g. products)]: bundle: Object<key:value> }
 */
function flattenResources(resources) {
    var bundles = resources.resourceBundles.bundles;
    var flatBundles = {};
    for (var key in bundles) {
        if (bundles.hasOwnProperty(key)) {
            // get last part of key to create a shorter key in the new object
            var newKey = key.split('.')[key.split('.').length - 1];
            var _a = bundles[key].properties, properties = _a === void 0 ? {} : _a;
            flatBundles[newKey] = properties;
        }
    }
    return flatBundles;
}

function getComponentsBy(components, comparator) {
    return components
        .reduce(function (result, component) {
        return result.concat(comparator(component) ? component : [], component.components ? getComponentsBy(component.components, comparator) : []);
    }, [])
        .filter(Boolean);
}

function getContentByRef(ref, pageModel) {
    if (!ref || !pageModel) {
        return undefined;
    }
    return get(pageModel, ref);
}

function getAlgoliaConfigFromBloomreach(pageModel) {
    var component = pageModel.page.components &&
        getComponentsBy(pageModel.page.components, function (x) { return x.label === 'Product catalog v2'; })[0];
    var models = (component || { models: undefined }).models;
    var ref = models && models.document && models.document.$ref;
    var content = ref ? getContentByRef(ref, pageModel) : {};
    var isEnabled = !!component;
    var presetQueryString = getPresetQueryString(content);
    var ruleContexts = content.ruleContexts || [];
    return {
        isEnabled: isEnabled,
        presetQueryString: presetQueryString,
        ruleContexts: ruleContexts,
    };
}
function getPresetQueryString(content) {
    var presetQueryString = (content.filterQuery || '').split('#')[0];
    var categoryExternalId = content.categoryExternalId || '';
    if (categoryExternalId) {
        var symbol = presetQueryString.includes('?') ? '&' : '?';
        presetQueryString += symbol + (FacetId.categoryExternalId + "=" + categoryExternalId);
    }
    return presetQueryString;
}

function getComponentByPath(path, pageModel) {
    var componentNames = path.split('/');
    if (!(pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) || !componentNames) {
        return;
    }
    var component = pageModel.page;
    var _loop_1 = function () {
        var name_1 = componentNames.shift();
        component = component === null || component === void 0 ? void 0 : component.components.find(function (c) { return c.name === name_1; });
    };
    while (componentNames.length && component) {
        _loop_1();
    }
    return component;
}

function getConfigurationForPath(path, pageModel) {
    var _a;
    var pathSegments = path.split('/');
    var currPath;
    var configuration = pageModel.page;
    while ((_a = configuration === null || configuration === void 0 ? void 0 : configuration.components) === null || _a === void 0 ? void 0 : _a[0]) {
        // match the next path segment
        currPath = pathSegments.shift();
        configuration = getConfigurationForPathSegment(currPath, configuration);
        if (configuration && pathSegments.length === 0) {
            // this was the last path segment and we retrieved configuration, so we can return the configuration
            return configuration;
        }
    }
    return null;
}
function getConfigurationForPathSegment(pathSegment, configuration) {
    for (var componentIdx in configuration.components) {
        if (configuration.components.hasOwnProperty(componentIdx)) {
            var component = configuration.components[componentIdx];
            // asterisk serves as a wildcard
            if (pathSegment === component.name || pathSegment === '*') {
                return component;
            }
        }
    }
    return null;
}

// Gets the content for the prescription modal from the pageModel
function getModalContent(pageModel) {
    var _a, _b, _c, _d;
    var components = (_a = pageModel.page) === null || _a === void 0 ? void 0 : _a.components;
    var mainContainer = components.find(function (comp) { return comp.name === 'main'; });
    var topContainer = mainContainer &&
        mainContainer.components &&
        mainContainer.components.find(function (comp) { return comp.name === 'top-container'; });
    var richText = topContainer &&
        topContainer.components &&
        topContainer.components.find(function (comp) { return comp.label === 'Rich Text'; });
    var richTextModal = richText && richText._meta.params && richText._meta.params.template === 'modal'
        ? richText
        : undefined;
    var contentRef = (_c = (_b = richTextModal === null || richTextModal === void 0 ? void 0 : richTextModal.models) === null || _b === void 0 ? void 0 : _b.document) === null || _c === void 0 ? void 0 : _c.$ref;
    if (!contentRef) {
        return;
    }
    var richTextContent = getContentByRef(contentRef, pageModel);
    return (_d = richTextContent === null || richTextContent === void 0 ? void 0 : richTextContent.content) === null || _d === void 0 ? void 0 : _d.value;
}

// TODO: change the return type to a locale interface here
var getNoAddOnsImage = function (pageModel) {
    var _a, _b, _c, _d;
    var imageRef = ((_c = (_b = (_a = getComponentsBy(pageModel.page.components, function (x) { return x.name === 'main'; })[0]) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b.document) === null || _c === void 0 ? void 0 : _c.$ref) || null;
    if (!imageRef) {
        return undefined;
    }
    return (_d = getContentByRef(imageRef, pageModel)) === null || _d === void 0 ? void 0 : _d.noAddonsImage;
};

function getPageSeo(pageModel) {
    var _a, _b;
    var seo = {
        canonicalUrl: '',
        description: '',
        image: {
            filename: '',
            description: null,
            url: '',
            mobileUrl: '',
        },
        title: '',
        type: '',
    };
    var components = (_b = (_a = pageModel.page) === null || _a === void 0 ? void 0 : _a.components) !== null && _b !== void 0 ? _b : [];
    var main = components.find(function (c) { return c.name === 'main'; });
    if (!main || !main.components || !main.components.length) {
        return seo;
    }
    var data = findSeoData(main.components);
    if (data !== undefined) {
        seo = data;
    }
    else {
        main.components.forEach(function (c) {
            if (c.components && c.components.length) {
                data = findSeoData(c.components);
                if (data !== undefined) {
                    seo = data;
                }
            }
        });
    }
    return seo;
}
var findSeoData = function (components) {
    var data = components.find(function (nestedC) { return nestedC.name === 'seo'; });
    if (!data || !data.models || !data.models.seoData) {
        return undefined;
    }
    return data.models.seoData;
};

var getProductTypeUsps = function (pageModel) {
    var _a, _b, _c;
    var uspRef = (pageModel.page.components && ((_c = (_b = (_a = getComponentsBy(pageModel.page.components, function (x) { return x.name === 'main'; })[0]) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b.document) === null || _c === void 0 ? void 0 : _c.$ref)) ||
        null;
    if (!uspRef) {
        return undefined;
    }
    return getContentByRef(uspRef, pageModel).usps;
};

function parseBloomreachImage(image) {
    var _a, _b;
    if (!image) {
        return undefined;
    }
    return {
        alt: image.description,
        original: {
            alt: image.description,
            url: ((_a = image.original) === null || _a === void 0 ? void 0 : _a.url) || '',
            dimensions: getDimensions(image.original),
        },
        mobile: {
            alt: image.description,
            url: ((_b = image.mobile) === null || _b === void 0 ? void 0 : _b.url) || '',
            dimensions: getDimensions(image.mobile),
        },
    };
}
function getDimensions(input) {
    return { w: (input === null || input === void 0 ? void 0 : input.width) || 0, h: (input === null || input === void 0 ? void 0 : input.height) || 0 };
}

function parseBloomreachLinks(links) {
    return ((links === null || links === void 0 ? void 0 : links.map(function (_a) {
        var url = _a.url, label = _a.label, style = _a.style, openInNewWindow = _a.openInNewWindow;
        return ({
            url: url,
            label: label,
            style: style,
            target: openInNewWindow ? 'external' : 'internal',
        });
    })) || []);
}

/**
 * Returns a session object for a client side request.
 *
 * @param session An object with session defaults.
 */
var getClientSession = function (defaults) {
    return __assign(__assign({}, defaults), { host: window.location.host, path: window.location.pathname + (window.location.search || ''), cookie: document.cookie, search: (window.location.search && QueryString.parse(window.location.search)) || {} });
};
/**
 * Returns a session object for a server side request.
 *
 * @param req An Express.Request object.
 * @param session An object with session defaults.
 */
var getServerSession = function (req, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return __assign(__assign({}, defaults), { host: req.headers.host, path: req.headers.pathname, cookie: req.headers.cookie, locale: req.locale, search: req.query });
};

var nonLetterGroupTitle = '#';
// TODO: replace with /^p{L}/u once IE11 support is dropped
var startsWithLetter = /^[a-zA-ZÀÈÌÒÙàèìòùÁÉÍÓÚÝáéíóúýÂÊÎÔÛâêîôûÃÑÕãñõÄËÏÖÜŸäëïöüŸçÇŒœßØøÅåÆæÞþÐð]/i;
var groupTitle = function (title) {
    return startsWithLetter.test(title) ? title === null || title === void 0 ? void 0 : title.charAt(0).toUpperCase() : nonLetterGroupTitle;
};
var groupBrands = function (items, maxGroupLength, locale) {
    if (maxGroupLength === void 0) { maxGroupLength = 4; }
    if (!items) {
        return [];
    }
    var currentTitle;
    return items
        .sort(function (a, b) {
        var aLetter = startsWithLetter.test(a.title);
        var bLetter = startsWithLetter.test(b.title);
        return aLetter && !bLetter
            ? 1
            : !aLetter && bLetter
                ? -1
                : a.title.localeCompare(b.title, locale, {
                    sensitivity: 'base',
                    usage: 'sort',
                    numeric: true,
                });
    })
        .reduce(function (result, item) {
        var title = groupTitle(item.title);
        var currentGroup = result[result.length - 1];
        if (title !== currentTitle) {
            currentTitle = title;
            currentGroup = { title: title, items: [] };
            result.push(currentGroup);
        }
        if (currentGroup.items.length === maxGroupLength) {
            currentGroup = { title: '', items: [] };
            result.push(currentGroup);
        }
        currentGroup.items.push(item);
        return result;
    }, []);
};

function parseBloomreachInputField(inputField) {
    return inputField
        ? {
            placeholder: inputField.placeholder,
            id: inputField.inputId,
            type: inputField.type || 'text',
        }
        : undefined;
}

var cmsUrls;
var isMultilingual = false;
var BloomreachService = function (multilingual) {
    if (multilingual === void 0) { multilingual = false; }
    setMultilingual(multilingual);
    function getMultilingual() {
        return isMultilingual;
    }
    function setMultilingual(value) {
        isMultilingual = value;
    }
    function getCmsUrls() {
        return cmsUrls;
    }
    function setCmsUrls(newCmsUrls) {
        cmsUrls = newCmsUrls;
    }
    function isCmsPreview(queryParams) {
        if (queryParams === void 0) { queryParams = {}; }
        var bloomreachParam = queryParams['bloomreach-preview'];
        return bloomreachParam !== undefined && bloomreachParam === 'true';
    }
    function getLocalizedCmsUrls(newCmsUrls, locale) {
        var localizedCmsUrls = __assign({}, newCmsUrls);
        if (locale) {
            locale = locale.replace('-', '_');
            localizedCmsUrls.live = __assign({}, localizedCmsUrls.live);
            localizedCmsUrls.preview = __assign({}, localizedCmsUrls.preview);
            localizedCmsUrls.live.channelPath += '/' + locale;
            localizedCmsUrls.preview.channelPath += '/' + locale;
        }
        return localizedCmsUrls;
    }
    function removeLocaleFromPath(request) {
        if (request.path) {
            // Remove locale from the path (Bloomreach setup prepends all URL with a locale)
            // This usecase may also happen if user opens a url with locale from sources like google search or typing in adress bar directly
            var locale = LocaleUtils.getLocaleFromUrl(request.path);
            request.path = locale
                ? request.path.replace("/" + locale.replace('-', '_'), '')
                : request.path;
        }
        return request;
    }
    function getBloomreachURL(request, newCmsUrls, locale) {
        return getMultilingual()
            ? getApiUrl(removeLocaleFromPath(request), getLocalizedCmsUrls(newCmsUrls, locale))
            : getApiUrl(request, newCmsUrls);
    }
    /**
     * Fetches a page model for the given url path
     */
    function fetchCmsPage(request, locale, cookie, dev) {
        if (dev === void 0) { dev = false; }
        return __awaiter(this, void 0, void 0, function () {
            var pageModel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchCmsPageWithResponse(request, locale, cookie, dev)];
                    case 1:
                        pageModel = (_a.sent()).pageModel;
                        return [2 /*return*/, pageModel];
                }
            });
        });
    }
    function fetchCmsPageWithResponse(request, locale, cookie, dev) {
        if (dev === void 0) { dev = false; }
        return __awaiter(this, void 0, void 0, function () {
            var url, response, pageModel, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!cmsUrls) {
                            throw new Error('cmsUrls not set.');
                        }
                        url = getBloomreachURL(request, cmsUrls, locale);
                        if (dev) {
                            console.log("Fetching " + url);
                        }
                        return [4 /*yield*/, fetch(url, { headers: { Cookie: cookie } })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.json()];
                    case 3:
                        pageModel = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error("Error! could not convert page model response to JSON for URL: " + url);
                        console.error(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        console.error("Error! Status code " + response.status + " while fetching CMS page data for URL: " + url);
                        _a.label = 7;
                    case 7: return [2 /*return*/, { pageModel: pageModel, response: response }];
                }
            });
        });
    }
    /**
     * Fetches a set of resource IDs from the Bloomreach resource api.
     * Resources are usually a list of keys with localized values.
     */
    function fetchCmsResource(resourceIds, locale, urls) {
        return __awaiter(this, void 0, void 0, function () {
            var localeStr, url, response, resources, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localeStr = locale.replace('-', '_');
                        url = createResourcesUrl(resourceIds, localeStr, urls);
                        return [4 /*yield*/, fetch(url)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.json()];
                    case 3:
                        resources = _a.sent();
                        return [2 /*return*/, flattenResources(resources)];
                    case 4:
                        err_2 = _a.sent();
                        console.error("Error! could not convert resources response to JSON for URL: " + url);
                        console.error(err_2);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        console.error("Error! Status code " + response.status + " while fetching CMS resources for URL: " + url);
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * Get all data needed to be able to render a page on the server side.
     * Mainly for SEO purposes.
     */
    function getPage(_a) {
        var url = _a.url, hostname = _a.hostname, cookie = _a.cookie, locale = _a.locale, routes = _a.routes, dev = _a.dev;
        return __awaiter(this, void 0, void 0, function () {
            var _b, path, pathname, _c, query, preview, request, _d, response, pageModel, pageMeta, pageTemplate, bloomreachCmsSettings, qstring, page, error_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 2, , 3]);
                        _b = parse(url, true), path = _b.path, pathname = _b.pathname, _c = _b.query, query = _c === void 0 ? {} : _c;
                        preview = isCmsPreview(query);
                        if (pathname &&
                            (pathname.indexOf('/_next/') > -1 ||
                                pathname.indexOf('/static/') > -1 ||
                                pathname.indexOf('/public/') > -1)) {
                            return [2 /*return*/, {}];
                        }
                        request = {
                            hostname: hostname,
                            path: path || '',
                        };
                        return [4 /*yield*/, fetchCmsPageWithResponse(request, locale, cookie, dev)];
                    case 1:
                        _d = _e.sent(), response = _d.response, pageModel = _d.pageModel;
                        pageMeta = getPageMeta(pageModel);
                        pageTemplate = getPageTemplate(pageModel, routes);
                        bloomreachCmsSettings = {
                            visitorId: getBloomreachVisitorId(response.headers),
                            apiUrl: {
                                live: createCmsUrl(cmsUrls.live, {
                                    context: false,
                                    channel: false,
                                    isMultilingual: getMultilingual(),
                                    locale: locale,
                                }),
                                preview: createCmsUrl(cmsUrls.preview, {
                                    context: false,
                                    channel: false,
                                    isMultilingual: getMultilingual(),
                                    locale: locale,
                                }),
                            },
                        };
                        qstring = QueryString.stringify(query, true);
                        page = __assign(__assign({ request: {
                                hostname: request.hostname,
                                path: pathname + (qstring && "?" + qstring),
                            }, locale: locale,
                            pageModel: pageModel,
                            preview: preview,
                            bloomreachCmsSettings: bloomreachCmsSettings, search: query }, pageTemplate), pageMeta);
                        return [2 /*return*/, page];
                    case 2:
                        error_1 = _e.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * Get additional meta data from the page model.
     */
    function getPageMeta(pageModel) {
        var pageRoutes = getNestedObject(pageModel, ['page', 'models', 'routes']);
        var productRoutesRef = getNestedObject(pageModel, ['page', 'models', 'productRoutes', '$ref']);
        var productType = getNestedObject(pageModel, ['page', 'models', 'productType']);
        var productRoutes = (getContentByRef(productRoutesRef, pageModel) || {}).productRoutes;
        var isSolaris = productType === 'Sunglasses';
        return {
            pageRoutes: pageRoutes,
            productRoutes: productRoutes,
            productType: productType,
            isSolaris: isSolaris,
        };
    }
    /**
     * Get relevant template data from the page model so we can render the main component
     */
    function getPageTemplate(pageModel, routes) {
        if (!routes.error) {
            throw new Error('No error route defined.');
        }
        // Check if we have a pageId to overwrite the template from the pageType as it is more specific
        var pageTypeId = getNestedObject(pageModel, ['page', 'models', 'pageId']);
        if (pageTypeId && routes[pageTypeId]) {
            return {
                templatePath: routes[pageTypeId],
                statusCode: 200,
            };
        }
        var pageType = getNestedObject(pageModel, ['page', 'models', 'pageType']);
        if (pageType && routes[pageType]) {
            // Map bloomreach pageType to our templates (pages directory)
            return {
                templatePath: routes[pageType],
                statusCode: 200,
            };
        }
        console.error("No matching route found for pageModel with pageType: " + pageType + " in resource api!");
        return {
            templatePath: routes.error,
            statusCode: 404,
        };
    }
    return {
        getCmsUrls: getCmsUrls,
        setCmsUrls: setCmsUrls,
        getMultilingual: getMultilingual,
        setMultilingual: setMultilingual,
        fetchCmsPage: fetchCmsPage,
        fetchCmsResource: fetchCmsResource,
        getPage: getPage,
        getPageMeta: getPageMeta,
        isCmsPreview: isCmsPreview,
        removeLocaleFromPath: removeLocaleFromPath,
    };
};
function getBloomreachVisitorId(headers) {
    var cookie;
    headers.forEach(function (val, key) { return key === 'set-cookie' && val.includes('_visitor=') && (cookie = val); });
    return cookie ? cookie.match(/\_visitor\=(.*?)\;/)[1] : undefined;
}

function withAnchor(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var withAnchor = function (props) {
        var anchorId = getNestedObject(props, ['configuration', '_meta', 'params', 'anchorId']);
        return anchorId && !props.preview ? (createElement("div", { className: "anchor-wrapper", id: anchorId, style: { marginTop: '-120px', paddingTop: '120px' } },
            createElement(Component, __assign({}, props)))) : (createElement(Component, __assign({}, props)));
    };
    withAnchor.displayName = "withAnchor(" + wrappedName + ")";
    return withAnchor;
}

// This is the key that BR uses to set the hidden property on a container component
var PARAMETER_HIDDEN = 'com.onehippo.cms7.targeting.TargetingParameterUtil.hide';
// Default properties on bloomreach content and meta objects
// that are always there, but we don't require on component level
var omitKeysContent = ['displayName', 'versionedNode', '_links', 'localeString', 'type'];
var omitKeysMeta = [PARAMETER_HIDDEN, 'document', 'mobile', 'tablet', 'desktop'];
function getBloomreachContent(ref, pageModel) {
    var content = getContentByRef(ref, pageModel) || {};
    return Object.keys(content).reduce(function (result, key) {
        var _a;
        return (omitKeysContent.includes(key) ? result : __assign(__assign({}, result), (_a = {}, _a[key] = content[key], _a)));
    }, {});
}
function getBloomreachMeta(config) {
    var _a, _b;
    var meta = __assign(__assign({}, (_a = config._meta) === null || _a === void 0 ? void 0 : _a.paramsInfo), (_b = config._meta) === null || _b === void 0 ? void 0 : _b.params);
    return Object.keys(meta).reduce(function (result, key) {
        var _a;
        return (omitKeysMeta.includes(key) ? result : __assign(__assign({}, result), (_a = {}, _a[key] = meta[key], _a)));
    }, {});
}
var getCommonParams = function (_a) {
    var title = _a.title, theme = _a.theme, template = _a.template;
    return (__assign(__assign(__assign({}, (isString(title) ? { title: title } : {})), (isString(theme) ? { theme: theme } : {})), (isString(template) ? { template: template } : {})));
};
var isComponentHidden = function (configuration) { var _a, _b; return ((_b = (_a = configuration._meta) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b[PARAMETER_HIDDEN]) === 'on'; };
function fetchPagedComponent(url, componentSlug, pageIndex) {
    if (pageIndex === void 0) { pageIndex = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("" + url + componentSlug + "&page=" + pageIndex, {
                        method: 'GET',
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.json()];
            }
        });
    });
}

function parseBloomreachArticles(config, pageModel) {
    var _a, _b, _c, _d;
    var _e = (_b = (_a = config.models) === null || _a === void 0 ? void 0 : _a.pageable) !== null && _b !== void 0 ? _b : {}, currentPage = _e.currentPage, nextPage = _e.nextPage, endPage = _e.endPage, _f = _e.items, items = _f === void 0 ? [] : _f;
    var highlightedRef = (_d = (_c = config.models) === null || _c === void 0 ? void 0 : _c.highlightedArticle) !== null && _d !== void 0 ? _d : {};
    var articles = items.map(function (_a) {
        var $ref = _a.$ref;
        return getBloomreachContent($ref, pageModel);
    });
    var highlighted = getBloomreachContent(highlightedRef.$ref, pageModel);
    return {
        highlighted: highlighted,
        paged: {
            items: articles,
            currentPage: currentPage,
            nextPage: nextPage,
            endPage: endPage,
        },
    };
}
var useBloomreachArticles = function (_a) {
    var apiUrl = _a.apiUrl, slug = _a.slug, pageModel = _a.pageModel, initialConfig = _a.initialConfig;
    var _b = __read(useState(1), 2), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = __read(useState(false), 2), loading = _c[0], setLoading = _c[1];
    var _d = __read(useState(), 2), error = _d[0], setError = _d[1];
    var _e = __read(useState(function () {
        return parseBloomreachArticles(initialConfig, pageModel);
    }), 2), result = _e[0], setResult = _e[1];
    var loadNextPage = useCallback(function () {
        result.paged.nextPage && setCurrentPage(result.paged.nextPage);
    }, [result.paged.nextPage]);
    if (!apiUrl || !slug) {
        var err = new Error("Failed to fetch Articles from Bloomreach, need valid settings but got: apiUrl: " + apiUrl + " and slug: " + slug);
        return { loading: loading, error: err, result: result, loadNextPage: loadNextPage };
    }
    useEffect(function () {
        if (currentPage === result.paged.currentPage) {
            return;
        }
        var current = true;
        setLoading(true);
        fetchPagedComponent(apiUrl, slug, currentPage)
            .then(function (res) {
            if (current) {
                var paged_1 = parseBloomreachArticles(res.page, res).paged;
                setResult(function (state) { return (__assign(__assign({}, state), { paged: __assign(__assign({}, paged_1), { items: __spread(state.paged.items, paged_1.items) }) })); });
                setLoading(false);
            }
        })
            .catch(function (err) {
            if (current) {
                console.error(err);
                setError(err);
                setLoading(false);
            }
        });
        return function () {
            current = false;
        };
    }, [apiUrl, slug, currentPage, result.paged.currentPage]);
    return { loading: loading, error: error, result: result, loadNextPage: loadNextPage };
};

/**
 * Receives a configuration for a Bloomreach container component
 * and maps it to our own CmsComponentData model
 */
function useBloomreachData(configuration, pageModel) {
    var _a, _b, _c, _d;
    var ref = ((_b = (_a = configuration.models) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.$ref) || '';
    var visibility = (_d = (_c = configuration.models) === null || _c === void 0 ? void 0 : _c.visibility) !== null && _d !== void 0 ? _d : [];
    var hidden = isComponentHidden(configuration);
    var meta = getBloomreachMeta(configuration);
    var commonParams = getCommonParams(meta);
    var content = useMemo(function () { return getBloomreachContent(ref, pageModel); }, [
        ref,
        pageModel,
    ]);
    return {
        ref: ref,
        data: __assign({ meta: meta,
            content: content,
            hidden: hidden,
            visibility: visibility }, commonParams),
    };
}

function useBloomreachPageable(configuration, pageModel) {
    var _a, _b, _c, _d, _e;
    var items = (_c = (_b = (_a = configuration.models) === null || _a === void 0 ? void 0 : _a.pageable) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [];
    var visibility = (_e = (_d = configuration.models) === null || _d === void 0 ? void 0 : _d.visibility) !== null && _e !== void 0 ? _e : [];
    var hidden = isComponentHidden(configuration);
    var meta = getBloomreachMeta(configuration);
    var commonParams = getCommonParams(meta);
    var content = useMemo(function () {
        var contentItems = items.map(function (_a) {
            var $ref = _a.$ref;
            return getBloomreachContent($ref, pageModel);
        });
        return { items: contentItems };
    }, [items, pageModel]);
    return {
        refs: items.map(function (_a) {
            var $ref = _a.$ref;
            return $ref;
        }),
        data: __assign({ meta: meta,
            content: content,
            hidden: hidden,
            visibility: visibility }, commonParams),
    };
}

var useBloomreachProductRoutes = function (pageModel, includeProductUrlSku) {
    var _a;
    var intl = useIntl();
    var routesRef = getNestedObject(pageModel, ['page', 'models', 'productRoutes', '$ref']);
    if (!routesRef) {
        console.log("No routes reference for page " + pageModel.id + ", " + pageModel.page.name);
    }
    var productRoutes = ((_a = getContentByRef(routesRef, pageModel)) !== null && _a !== void 0 ? _a : {
        productRoutes: [],
    }).productRoutes;
    var hasRoutes = routesRef && Array.isArray(productRoutes);
    if (!hasRoutes) {
        console.log("Could not get productRoutes $ref for page " + pageModel.id + ", " + pageModel.page.name + ", got: " + String(productRoutes));
    }
    var sortedProductRoutes = hasRoutes
        ? productRoutes.reduce(function (acc, route) {
            acc.byProductType[route.productType] = route.route;
            acc.byId[route.productType] = route.route;
            acc.checksum = acc.checksum + "|" + route.id + ":" + route.route;
            return acc;
        }, { byProductType: {}, byId: {}, checksum: '' })
        : null;
    var formatProductUrl = useCallback(function (product) {
        if (!CommerceToolsApi.isProductTypeName(product.productType) || !sortedProductRoutes) {
            return '#';
        }
        var targetPath = sortedProductRoutes.byProductType[product.productType];
        var slug = getLocalizedValue(product.slug, intl.locale);
        var sku = !!product.sku && includeProductUrlSku ? "/" + product.sku : '';
        return targetPath + "/" + slug + sku;
    }, [sortedProductRoutes === null || sortedProductRoutes === void 0 ? void 0 : sortedProductRoutes.checksum, includeProductUrlSku]);
    return useMemo(function () { return [{ hasRoutes: hasRoutes }, { formatProductUrl: formatProductUrl }]; }, [
        hasRoutes,
        formatProductUrl,
    ]);
};

/**
 * List of breakpoint names supported by Bloomreach. By using this list, components will always be visible
 * in any new breakpoint by default (no option to hide them until Bloomreach supports the new breakpoint)
 * If a breakpoint ever gets removed/replaced in the original enum, Bloomreach needs to be updated first to support the change
 */
var supportedBreakpoints = [
    MediaQuery.BreakpointName.PHONE,
    MediaQuery.BreakpointName.TABLET_PORTRAIT,
    MediaQuery.BreakpointName.TABLET_LANDSCAPE,
    MediaQuery.BreakpointName.DESKTOP,
];
var isComponentVisible = function (breakpoint, visibility) {
    return !visibility || !supportedBreakpoints.includes(breakpoint) || visibility.includes(breakpoint);
};
function useBreakpointVisibility(_a) {
    var configuration = _a.configuration, preview = _a.preview;
    var breakpoint = MediaQuery.useBreakpoint();
    var containerVisibility = getNestedObject(configuration, ['models', 'visibility']);
    var contentVisibility = getNestedObject(configuration, ['visibility']);
    var visibility = containerVisibility
        ? containerVisibility
        : contentVisibility;
    return preview || isComponentVisible(breakpoint, visibility);
}

function withBloomreachData(Component) {
    var displayName = getDisplayName(Component);
    var WithBloomreachData = function (props) {
        var configuration = props.configuration, pageModel = props.pageModel;
        var _a = useBloomreachData(configuration, pageModel), ref = _a.ref, data = _a.data;
        if (!data.content) {
            console.error("Tried to render CmsComponent " + displayName + " without content object (ref: " + ref + ")");
            return null;
        }
        return createElement(Component, __assign({}, data, props));
    };
    WithBloomreachData.displayName = "WithBloomreachData(" + displayName + ")";
    return WithBloomreachData;
}

function withBloomreachPageable(Component) {
    var displayName = getDisplayName(Component);
    var WithBloomreachPageable = function (props) {
        var _a;
        var configuration = props.configuration, pageModel = props.pageModel;
        var _b = useBloomreachPageable(configuration, pageModel), refs = _b.refs, data = _b.data;
        if (!((_a = data.content.items) === null || _a === void 0 ? void 0 : _a.length)) {
            console.error("Trying to render Bloomreach pageable component: " + displayName + ", but found no content documents. Refs: " + refs);
            return null;
        }
        return createElement(Component, __assign({}, data, props));
    };
    WithBloomreachPageable.displayName = "WithBloomreachPageable(" + displayName + ")";
    return WithBloomreachPageable;
}

function withBreakpointVisibility(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var WithBreakpointVisibility = function (props) {
        return useBreakpointVisibility(props) ? createElement(Component, __assign({}, props)) : null;
    };
    WithBreakpointVisibility.displayName = "WithBreakpointVisibility(" + wrappedName + ")";
    return WithBreakpointVisibility;
}

function addBeginComment(htmlElm, position, configuration, preview) {
    var beginNodeSpan = getNestedObject(configuration, ['_meta', 'beginNodeSpan', 0, 'data']);
    if (preview &&
        htmlElm &&
        beginNodeSpan &&
        !htmlElm.classList.contains('cms-begin-comment-added')) {
        htmlElm.insertAdjacentHTML(position, configuration._meta.beginNodeSpan[0].data);
        // adding an HTML class to ensure comments are not added more than once
        // this is because the comments are added through the DOM and not by React
        // so this function is fired on every re-render of the parent component
        htmlElm.classList.add('cms-begin-comment-added');
    }
}
var ManageContentButton = /** @class */ (function (_super) {
    __extends(ManageContentButton, _super);
    function ManageContentButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManageContentButton.addButton = function (htmlElm, configuration, preview) {
        addBeginComment(htmlElm, 'afterbegin', configuration, preview);
    };
    ManageContentButton.prototype.render = function () {
        var content = this.props.content || this.props.menu || {};
        var preview = this.props.preview;
        var styles = __assign(__assign({}, this.props.styles), { position: 'relative' });
        return (React__default.createElement("div", { style: styles },
            React__default.createElement("span", { ref: function (editContentElm) {
                    ManageContentButton.addButton(editContentElm, content, preview);
                } })));
    };
    return ManageContentButton;
}(PureComponent));

/**
 * Link to a page outside the current application.
 */
var TYPE_LINK_EXTERNAL = 'external';
/**
 * Link to a page inside the current application.
 */
var TYPE_LINK_INTERNAL = 'internal';
/**
 * Link to a CMS resource.
 */
var TYPE_LINK_RESOURCE = 'resource';
var TYPE_META_COMMENT = 'comment';
/**
 * Generic component type.
 */
var TYPE_COMPONENT = 'COMPONENT';
/**
 * Container item type.
 */
var TYPE_COMPONENT_CONTAINER_ITEM = 'CONTAINER_ITEM_COMPONENT';
/**
 * Container type.
 */
var TYPE_COMPONENT_CONTAINER = 'CONTAINER_COMPONENT';

/**
 * This HoC requires the passed component to have a content object on its props
 * This means when used in combination with withBloomreachData hoc, this hoc should come after
 *  compose(withBloomreachData, withEditableContent)
 */
function withEditableContent(Component) {
    var displayName = getDisplayName(Component);
    var WithEditableContent = function (props) {
        var preview = props.preview, content = props.content;
        if (!content) {
            console.error("Cannot use withEditableContent HoC on component: " + displayName + " without a valid content object: " + content);
            return createElement(Component, __assign({}, props));
        }
        if (preview) {
            return (createElement(Fragment, null,
                createElement(ManageContentButton, { content: content, preview: preview }),
                createElement(Component, __assign({}, props))));
        }
        return createElement(Component, __assign({}, props));
    };
    WithEditableContent.displayName = "WithEditableContent(" + displayName + ")";
    return WithEditableContent;
}

var CmsAccordionItem = withEditableContent(function (_a) {
    var content = _a.content, expanded = _a.expanded, headingLevel = _a.headingLevel;
    var _b;
    return (createElement(AccordionItem, { id: content.id, label: content.title, expanded: expanded, headingLevel: headingLevel }, ReactHtmlParser((_b = content.content) === null || _b === void 0 ? void 0 : _b.value)));
});
var CmsAccordion = function (_a) {
    var headingLevel = _a.headingLevel, meta = _a.meta, content = _a.content, preview = _a.preview, hidden = _a.hidden;
    if (hidden) {
        return null;
    }
    return (createElement(Accordion, null, content.items.map(function (item, i) { return (createElement(CmsAccordionItem, { key: item.id, content: item, headingLevel: headingLevel, preview: preview, expanded: meta.expandedByDefault === "" + (i + 1) })); })));
};
var CmsAccordion$1 = compose(withBreakpointVisibility, withBloomreachPageable, withAnchor)(CmsAccordion);

var CmsArticle = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel;
    var _b;
    var article = (_b = configuration.models) === null || _b === void 0 ? void 0 : _b.document;
    var template = useBloomreachData(configuration, pageModel).data.template;
    if (!article) {
        return null;
    }
    var images = parseBloomreachImage(article.image);
    switch (template) {
        case 'article-banner-preview':
            return (createElement(Article$1, null, images && (createElement(Banner, { useContainer: true, image: images.original, mobileImage: images.mobile, link: { url: (article === null || article === void 0 ? void 0 : article.url) || '', target: 'internal' } }))));
        default:
            return createElement("h5", null, "Unsupported article template " + template);
    }
};
var Article = compose(withAnchor, withBreakpointVisibility)(CmsArticle);

var CmsArticleCollectionItem = withEditableContent(function (_a) {
    var content = _a.content;
    var coverImage = content.coverImage, url = content.url, title = content.title, summary = content.summary;
    var image = parseBloomreachImage(coverImage);
    if (!image) {
        console.error('Missing coverImage');
        return null;
    }
    var original = image.original;
    return (createElement(HighlightedContentItem, { image: original, text: summary, title: title, link: { url: url, target: 'internal' } }));
});
var CmsArticleCollection = function (_a) {
    var content = _a.content, preview = _a.preview, hidden = _a.hidden;
    if (hidden) {
        return null;
    }
    return (createElement(HighlightedContent, null, content.items.map(function (item) { return (createElement(CmsArticleCollectionItem, { key: item.id, content: item, preview: preview })); })));
};
var CmsArticleCollection$1 = compose(withBreakpointVisibility, withBloomreachPageable, withEditableContent, withAnchor)(CmsArticleCollection);

var CmsBanner = function (_a) {
    var content = _a.content, template = _a.template, meta = _a.meta, hidden = _a.hidden;
    var title = content.title, description = content.description, richText = content.content;
    var image = parseBloomreachImage(content.image);
    var links = parseBloomreachLinks(content.links);
    if (hidden) {
        return null;
    }
    if (!image) {
        console.error('Missing image');
        return null;
    }
    var original = image.original, mobile = image.mobile;
    switch (template) {
        case 'full-width':
            return createElement(Banner, { image: original, mobileImage: mobile, link: links[0] });
        case 'top-banner':
            return (createElement(Banner, { image: original, mobileImage: mobile, link: links[0], useContainer: true, useLazyLoading: false }));
        case 'content-banner':
            return (createElement(ContentBanner, { image: original, mobileImage: mobile, links: links, title: title, text: description, textColor: meta.textColor }));
        case 'rich-banner':
            return (createElement(RichBanner, __assign({}, meta, { image: original, mobileImage: mobile, richText: richText === null || richText === void 0 ? void 0 : richText.value, link: links.find(function (l) { return l.style === 'image'; }) })));
        default:
            return createElement("h5", null, "Banner with template: " + template + " is not defined in CmsBanner component.");
    }
};
var CmsBanner$1 = compose(withBloomreachData, withEditableContent, withBreakpointVisibility, withAnchor)(CmsBanner);

var CmsBannerCollectionItem = withEditableContent(function (_a) {
    var content = _a.content, template = _a.template;
    var title = content.title, description = content.description, richText = content.content;
    var image = parseBloomreachImage(content.image);
    var links = parseBloomreachLinks(content.links);
    if (!image) {
        console.error('Missing image');
        return null;
    }
    var original = image.original, mobile = image.mobile;
    switch (template) {
        case 'certificates':
            return createElement(CertificatesItem, { image: original, link: links[0], title: title, text: description });
        case 'main-categories':
            return createElement(CategoryLinksItem, { image: original, link: links[0], title: title });
        case 'usp':
            return (createElement(HighlightedContentItem, { image: original, link: links[0], title: title, text: description }));
        case 'promotion-banner':
        case 'split-header-promotion':
            return (createElement(PromotionBannersItem, { image: original, mobileImage: mobile, link: links[0], title: title, text: description, fullWidth: template === 'split-header-promotion' }));
        case 'rich-banner':
            return (createElement(RichBanner, { image: original, mobileImage: mobile, richText: richText === null || richText === void 0 ? void 0 : richText.value, link: links.find(function (l) { return l.style === 'image'; }), backgroundColor: "white", textColor: "black", bannerWidth: "full", layout: "collection" }));
        default:
            return null;
    }
});
var CmsBannerCollection = function (_a) {
    var content = _a.content, template = _a.template, preview = _a.preview, hidden = _a.hidden;
    var items = content.items.map(function (item) { return (createElement(CmsBannerCollectionItem, { key: item.id, template: template, content: item, preview: preview })); });
    if (hidden) {
        return null;
    }
    switch (template) {
        case 'certificates':
            return createElement(Certificates, null, items);
        case 'main-categories':
            return createElement(CategoryLinks, null, items);
        case 'usp':
            return createElement(HighlightedContent, null, items);
        case 'promotion-banner':
        case 'split-header-promotion':
            return (createElement(PromotionBanners, { fullWidth: template === 'split-header-promotion' }, items));
        case 'rich-banner':
            return (createElement(Container, null,
                createElement(FlexLayout, { justify: "space-between", wrap: "wrap" }, items)));
        default:
            return (createElement("h5", null, "Banner collection with template: " + template + " is not defined in CmsBannerCollection component."));
    }
};
var CmsBannerCollection$1 = compose(withBloomreachPageable, withBreakpointVisibility, withAnchor)(CmsBannerCollection);

var CmsBlogCollectionItem = withEditableContent(function (_a) {
    var content = _a.content;
    var title = content.title, summary = content.summary, url = content.url;
    var coverImage = parseBloomreachImage(content.coverImage);
    if (!coverImage) {
        console.error('Missing coverImage');
        return null;
    }
    return (createElement(HighlightedContentItem, { image: coverImage.original, title: title, text: summary, link: !!url ? { url: url, target: 'internal' } : undefined }));
});
var CmsBlogCollection = function (_a) {
    var content = _a.content, preview = _a.preview;
    return (createElement(HighlightedContent, null, content.items.map(function (item) { return (createElement(CmsBlogCollectionItem, { key: item.id, content: item, preview: preview })); })));
};
var BlogCollection = compose(withBreakpointVisibility, withBloomreachPageable, withAnchor)(CmsBlogCollection);

var initialSettings = {
    visitorId: undefined,
    apiUrl: {
        live: '',
        preview: '',
    },
};
var BloomreachCmsContext = React__default.createContext(initialSettings);
function BloomreachCmsProvider(_a) {
    var settings = _a.settings, children = _a.children;
    return (React__default.createElement(BloomreachCmsContext.Provider, { value: __assign(__assign({}, initialSettings), settings) }, children));
}
function withBloomreachCms(Wrapped) {
    function WithBloomreachCms(props) {
        return (React__default.createElement(BloomreachCmsContext.Consumer, null, function (bloomreachSettings) { return (React__default.createElement(Wrapped, __assign({}, props, { bloomreachCms: bloomreachSettings }))); }));
    }
    var wrappedName = Wrapped.displayName || Wrapped.name || 'Component';
    WithBloomreachCms.displayName = "WithBloomreachCms(" + wrappedName + ")";
    return WithBloomreachCms;
}

var emptyUrl = { scheme: '', hostname: '', port: '' };
var initialValue = Object.freeze({
    cmsUrls: { live: emptyUrl, preview: emptyUrl },
    componentDefinitions: {},
    pageModel: {},
    preview: false,
    request: { hostname: '', path: '' },
});
/**
 * Note: do not use BloomreachContext.Provider directly. Instead, import {
 * BloomreachProvider } from './BloomreachProvider'. It's in a separate module
 * to avoid a circular dependency between ../component-definitions and
 * ../containers.
 */
var BloomreachContext = createContext(initialValue);
function useBloomreach() {
    return useContext(BloomreachContext);
}

var CmsBlogOverviewItem = withEditableContent(function (_a) {
    var content = _a.content;
    var _b = useIntl(), locale = _b.locale, getLabel = _b.getLabel;
    var title = content.title, coverImage = content.coverImage, readingTime = content.readingTime, publishDate = content.publishDate, summary = content.summary, url = content.url;
    var image = parseBloomreachImage(coverImage);
    return (createElement(BlogCard, { url: url, title: title, summary: summary, readingTime: readingTime, publishDate: publishDate, image: image === null || image === void 0 ? void 0 : image.original, mobileImage: image === null || image === void 0 ? void 0 : image.mobile, locale: locale, minutesLabel: getLabel('blog.minutesToRead') }));
});
var CmsBlogOverview = function (_a) {
    var pageModel = _a.pageModel, configuration = _a.configuration, preview = _a.preview;
    var _b, _c, _d, _e, _f;
    var getLabel = useIntl().getLabel;
    var apiUrl = useContext(BloomreachCmsContext).apiUrl;
    var title = (_d = (_c = (_b = configuration._meta) === null || _b === void 0 ? void 0 : _b.params) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : '';
    var slug = (_f = (_e = configuration._links) === null || _e === void 0 ? void 0 : _e.componentRendering) === null || _f === void 0 ? void 0 : _f.href;
    var _g = useBloomreachArticles({
        slug: slug,
        pageModel: pageModel,
        initialConfig: configuration,
        apiUrl: preview ? apiUrl.preview : apiUrl.live,
    }), loading = _g.loading, error = _g.error, result = _g.result, loadNextPage = _g.loadNextPage;
    if (error) {
        console.error('Failed to fetch bloomreach more articles from Bloomreach: ', error);
        return null;
    }
    var highlighted = result.highlighted, paged = result.paged;
    var currentPage = paged.currentPage, nextPage = paged.nextPage, endPage = paged.endPage;
    var hasMoreItems = nextPage !== null && nextPage !== currentPage && nextPage <= endPage;
    var image = parseBloomreachImage(highlighted.coverImage);
    return (createElement(Fragment, null,
        highlighted && image && (createElement(BlogHero, { image: image.original, mobileImage: image.mobile, title: highlighted.title, link: highlighted.url, summary: highlighted.summary, readMoreLabel: getLabel('blog.readArticle') })),
        createElement(BlogList, { title: title, noArticlesLabel: getLabel('blog.noArticles') }, paged.items.map(function (item) { return (createElement(CmsBlogOverviewItem, { key: item.id, content: item, preview: preview })); })),
        hasMoreItems && (createElement("div", { className: "blog-list__show-more" },
            createElement(Button, { className: "blog-list__button", variant: "outline", color: "primary", caption: getLabel('blog.articles.showMore'), isLoading: loading, onClick: loadNextPage })))));
};
var BlogOverview = compose(withBreakpointVisibility, withAnchor)(CmsBlogOverview);

var CmsExclusiveBrandsItem = withEditableContent(function (_a) {
    var content = _a.content;
    if (!content.brandLogo) {
        console.error('Missing brandLogo');
        return null;
    }
    return (React__default.createElement(ExclusiveBrandsItem, { title: content.title, url: content.url, logoSrc: content.brandLogo.url }));
});
var CmsBrandCollection = function (_a) {
    var pageModel = _a.pageModel, content = _a.content, template = _a.template, preview = _a.preview;
    switch (template) {
        case 'exclusive-brands':
            return (React__default.createElement(ExclusiveBrands, null, content.items.map(function (brand) { return (React__default.createElement(CmsExclusiveBrandsItem, { content: brand, preview: preview, key: brand.id })); })));
        default:
            return React__default.createElement("h5", null,
                "Banner of type ",
                template,
                " not defined in BrandCollection");
    }
};
var BrandCollection = compose(withAnchor, withBloomreachPageable, withBreakpointVisibility)(CmsBrandCollection);

var CmsBrandListItem = withEditableContent(function (_a) {
    var content = _a.content;
    return React__default.createElement(BrandListItem, { url: content.url }, content.title);
});
var getLocale = function (pageModel) {
    var _a, _b, _c, _d;
    var locale = ((_b = (_a = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b.locale) || ((_d = (_c = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page) === null || _c === void 0 ? void 0 : _c.models) === null || _d === void 0 ? void 0 : _d.defaultLocale);
    if (locale && typeof locale === 'string') {
        return Util.getLanguageForLocale(locale);
    }
};
var CmsBrandList = function (_a) {
    var pageModel = _a.pageModel, content = _a.content, meta = _a.meta, template = _a.template, preview = _a.preview;
    switch (template) {
        case 'brand-list':
            var locale = getLocale(pageModel);
            var groups = groupBrands(content.items, 4, locale);
            return (React__default.createElement(BrandList$1, { title: String(meta.title) }, groups.map(function (_a, i) {
                var title = _a.title, items = _a.items;
                return (React__default.createElement(BrandListGroup, { title: title, key: i }, items.map(function (brand) { return (React__default.createElement(CmsBrandListItem, { content: brand, preview: preview, key: brand.id })); })));
            })));
        default:
            return React__default.createElement("h5", null,
                "Banner of type ",
                template,
                " not defined in BrandList");
    }
};
var BrandList = compose(withAnchor, withBloomreachPageable, withBreakpointVisibility)(CmsBrandList);

var CmsCarouselItem = withEditableContent(function (_a) {
    var content = _a.content;
    var image = parseBloomreachImage(content.image);
    var _b = __read(parseBloomreachLinks(content.links), 1), link = _b[0];
    if (!image) {
        return null;
    }
    return createElement(Banner, { image: image.original, mobileImage: image.mobile, link: link });
});
var CmsCarousel = function (_a) {
    var content = _a.content, preview = _a.preview;
    return (createElement(Carousel, { autoLoop: !preview }, content.items.map(function (item) { return (createElement(CmsCarouselItem, { key: item.id, content: item, preview: preview })); })));
};
var CmsCarousel$1 = compose(withBreakpointVisibility, withAnchor, withBloomreachPageable)(CmsCarousel);

/**
 * This component wraps the component from the SDK that renders
 * any container-component from bloomreach based on the passed path.
 *
 * Any components inside this container will be rendered based on the
 * ComponentDefinitions we pass to SDK's page component.
 *
 * This component can be used to place certain containers in a page layout.
 * @example usage
 *   <Page>
 *     <CmsComponentSlot path="main/top-container" />
 *     <Cart />
 *     <SupportFooter />
 *     <CmsComponentSlot path="main/bottom-container" />
 *   </Page>
 */
var CmsComponentSlot = function (_a) {
    var _b = _a.path, path = _b === void 0 ? 'main' : _b;
    return createElement(RenderCmsComponent, { path: path });
};

var CmsDynamicRoutes = function (_a) {
    var pageModel = _a.pageModel, children = _a.children, _b = _a.includeProductUrlSku, includeProductUrlSku = _b === void 0 ? true : _b;
    var _c = __read(useBloomreachProductRoutes(pageModel, includeProductUrlSku), 2), hasRoutes = _c[0].hasRoutes, routeFormatters = _c[1];
    if (!children || !hasRoutes) {
        return null;
    }
    return children(routeFormatters);
};

var CustomPackage = function (_a) {
    var meta = _a.meta, componentMap = _a.componentMap, preview = _a.preview;
    var packageId = meta.packageId;
    var element = componentMap[packageId];
    if (!element) {
        console.warn("CmsCustomPackage: Tried to render a custom component with id: \"" + packageId + "\", but was not found in componentMap: ", componentMap);
        return preview ? createElement("div", null, "No component found for Custom Package ID: \"" + packageId + "\"") : null;
    }
    return createElement(element.type, __assign({}, element.props));
};
var Composed = compose(withBreakpointVisibility, withBloomreachData, withAnchor)(CustomPackage);
// TODO: we should probably set the custom component mapping on the context
//  so we can access it a bit easier
var CmsCustomPackage = function (componentMap) { return function (props) {
    return createElement(Composed, __assign({}, props, { componentMap: componentMap }));
}; };

var CmsIframe = function (_a) {
    var configuration = _a.configuration;
    var _b;
    var iframeContent = (_b = configuration.models) === null || _b === void 0 ? void 0 : _b.iframe;
    if (!iframeContent) {
        return null;
    }
    var source = iframeContent.source, scrolling = iframeContent.scrolling, height = iframeContent.height, position = iframeContent.position;
    return createElement(IFrame, { source: source, scrolling: scrolling, height: height, position: position });
};
var CmsIframe$1 = compose(withAnchor, withBreakpointVisibility)(CmsIframe);

var CmsLinkList = function (_a) {
    var content = _a.content;
    return (React__default.createElement(Container, null,
        React__default.createElement(ContentTabs, { links: content.iconLinkCompoundList.map(function (_a) {
                var link = _a.link;
                return link;
            }) })));
};
var CmsLinkList$1 = compose(withAnchor, withBloomreachData, withBreakpointVisibility)(CmsLinkList);

var RuntimeContext = createContext({});

var CmsRecommendedProducts = function (_a) {
    var intl = _a.intl, meta = _a.meta, pageModel = _a.pageModel;
    var publicRuntimeConfig = React__default.useContext(RuntimeContext);
    return (React__default.createElement(CmsDynamicRoutes, { pageModel: pageModel }, function (routeFormatters) {
        var _a;
        return (React__default.createElement(FeaturedProducts, { skus: meta.recommendedProducts || [], formatProductUrl: routeFormatters.formatProductUrl, staticsUrl: ((_a = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.grandvision) === null || _a === void 0 ? void 0 : _a.staticsUrl) || '', title: intl.getLabel('blog.content.recommendedProducts.title') }));
    }));
};
var CmsRecommendedProducts$1 = compose(withBloomreachData, withIntl)(CmsRecommendedProducts);

var CmsVideo = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel;
    var _b;
    var meta = useBloomreachData(configuration, pageModel).data.meta;
    var videoUrl = isString(meta.videoUrl) ? meta.videoUrl : undefined;
    var coverImage = ((_b = configuration === null || configuration === void 0 ? void 0 : configuration.models) === null || _b === void 0 ? void 0 : _b.coverImage) || {};
    if (!videoUrl) {
        return null;
    }
    return createElement(Video, { videoUrl: videoUrl, coverImage: coverImage });
};
var CmsVideo$1 = memo(withBreakpointVisibility(withAnchor(CmsVideo)));

var CmsWidget = function (_a) {
    var content = _a.content, hidden = _a.hidden, template = _a.template;
    var _b, _c;
    var title = content.title, links = content.links, inputField = content.inputField;
    var _d = __read(parseBloomreachLinks(links), 1), link = _d[0];
    var input = parseBloomreachInputField(inputField);
    var publicRuntimeConfig = useContext(RuntimeContext);
    var features = (_c = (_b = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.grandvision) === null || _b === void 0 ? void 0 : _b.features) !== null && _c !== void 0 ? _c : [];
    if (hidden) {
        return null;
    }
    if (!input) {
        console.error('Missing inputField');
        return null;
    }
    if (!link) {
        console.error('Missing link');
        return null;
    }
    switch (template) {
        case 'book-eye-check':
            return (createElement(BookAppointment, { title: title, link: link, inputField: input, isLocationEnabled: features.includes('GPS_STORES'), isPlacePredictionsEnabled: features.includes('STORES_PLACE_PREDICTIONS') }));
        default:
            return createElement("h5", null, "Widget of type: " + template + " is not defined.");
    }
};
var CmsWidget$1 = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsWidget);

var blockMap = {
    accordion: CmsAccordion$1,
    articleCollection: CmsArticleCollection$1,
    banner: CmsBanner$1,
    bannerCollection: CmsBannerCollection$1,
    carousel: CmsCarousel$1,
    customPackageComponent: CmsCustomPackage,
    iFrame: CmsIframe$1,
    linkList: CmsLinkList$1,
    recommendedProducts: CmsRecommendedProducts$1,
    video: CmsVideo$1,
    widget: CmsWidget$1,
};
function getComponentForBlockType(type) {
    var Component = blockMap[type];
    if (!Component) {
        console.log("Missing Component for content block type: " + type);
        return;
    }
    return Component;
}
function mapBlockToConfiguration(_a) {
    var anchorId = _a.anchorId, coverImage = _a.coverImage, document = _a.document, expandedByDefault = _a.expandedByDefault, packageId = _a.packageId, recommendedProducts = _a.recommendedProducts, _b = _a.template, template = _b === void 0 ? 'default' : _b, videoUrl = _a.videoUrl, visibility = _a.visibility, imageWidth = _a.imageWidth, imageAlignment = _a.imageAlignment, bannerWidth = _a.bannerWidth, textColor = _a.textColor, backgroundColor = _a.backgroundColor, source = _a.source, height = _a.height, scrolling = _a.scrolling;
    return {
        models: {
            coverImage: coverImage,
            document: document,
            pageable: {
                items: document,
            },
            visibility: visibility,
            iframe: {
                source: source,
                height: height,
                scrolling: scrolling,
            }
        },
        _meta: {
            params: {
                anchorId: anchorId,
                expandedByDefault: expandedByDefault,
                packageId: packageId,
                recommendedProducts: recommendedProducts,
                template: template,
                videoUrl: videoUrl,
                imageWidth: imageWidth,
                imageAlignment: imageAlignment,
                bannerWidth: bannerWidth,
                textColor: textColor,
                backgroundColor: backgroundColor,
            },
        },
    };
}
var ContentBlock = function (_a) {
    var contentBlock = _a.contentBlock, customComponents = _a.customComponents, pageModel = _a.pageModel, preview = _a.preview, routeFormatters = _a.routeFormatters;
    if (contentBlock.type === 'richText') {
        var cmsComponentProps = {
            configuration: mapBlockToConfiguration(contentBlock),
            preview: !!preview,
            pageModel: {},
        };
        return useBreakpointVisibility(cmsComponentProps) ? (React__default.createElement(RichTextArea, __assign({ content: contentBlock.html || '', backgroundColor: contentBlock.backgroundColor, textColor: contentBlock.textColor }, routeFormatters))) : null;
    }
    var Component = getComponentForBlockType(contentBlock.type);
    return Component ? (React__default.createElement(Component, { configuration: mapBlockToConfiguration(contentBlock), pageModel: pageModel, preview: preview, componentMap: customComponents })) : null;
};
var ContentBlock$1 = compose(withAnchor, withIntl)(ContentBlock);

var CmsContentBlocks = function (_a) {
    var contentBlocks = _a.contentBlocks, customComponents = _a.customComponents, pageModel = _a.pageModel, preview = _a.preview;
    return (createElement(CmsDynamicRoutes, { pageModel: pageModel }, function (routeFormatters) { return (createElement(Fragment, null, contentBlocks
        .map(function (contentBlock, key) {
        return createElement(ContentBlock$1, { key: "block-" + key, contentBlock: contentBlock, pageModel: pageModel, routeFormatters: routeFormatters, customComponents: customComponents, preview: preview });
    }))); }));
};

var DIRECTORY_ROOT = 'index';
var LABEL_NAMESPACE = 'breadcrumb.breadcrumb';
function convertUrlSegmentToLabel(level) {
    return StringUtils.upFirst(level.replace(/-/g, ' '));
}
function getUrlSegments(url) {
    return url
        .split('/')
        .filter(function (segment) { return segment.length && segment !== 'home'; })
        .slice(0, -1); // don't include the last segment but use the display name instead (see below).
}
function createBreadcrumbs(urlSegments, getLabel) {
    return __spread([
        {
            name: getLabel(LABEL_NAMESPACE + ".home"),
            url: '/',
        }
    ], urlSegments.map(function (segment, index) {
        var previous = urlSegments.slice(0, index).join('/');
        var label = getLabel(LABEL_NAMESPACE + "." + segment);
        var name = label !== "[" + LABEL_NAMESPACE + "." + segment + "]"
            ? getLabel(LABEL_NAMESPACE + "." + segment)
            : convertUrlSegmentToLabel(segment);
        return {
            url: "/" + (previous && previous + "/") + segment,
            name: name,
        };
    }));
}
var CmsContentBreadcrumbs = function (_a) {
    var displayName = _a.displayName, name = _a.name, url = _a.url;
    if (!url) {
        return null;
    }
    var getLabel = useIntl().getLabel;
    var urlSegments = getUrlSegments(url);
    var pages = createBreadcrumbs(urlSegments, getLabel);
    // Append the display name of the currently viewed page as the last page.
    if (name !== DIRECTORY_ROOT) {
        pages.push({
            url: "/" + url,
            name: displayName,
        });
    }
    return (createElement("div", { className: "breadcrumbs-wrapper" },
        createElement(Breadcrumbs, { pages: pages })));
};

var CmsCookieNotification = function (_a) {
    var pageModel = _a.pageModel, preview = _a.preview, onAllowCookies = _a.onAllowCookies, bloomreachCms = _a.bloomreachCms;
    var _b;
    // Cookie is part of the footer model in Bloomreach
    var configuration = getConfigurationForPath('footer', pageModel);
    if (!configuration || !configuration.components || !configuration.components.length) {
        console.error('No configuration or components found for Footer in CMS model!');
        return null;
    }
    var cookieConfig = configuration.components.find(function (comp) { return comp.name === 'cookie-consent'; });
    var contentRef = (_b = cookieConfig.models) === null || _b === void 0 ? void 0 : _b.document.$ref;
    if (!contentRef) {
        console.error('No valid content $ref supplied for cookie consent!');
        return null;
    }
    var content = getContentByRef(contentRef, pageModel);
    var allowCookies = useCallback(function () {
        onAllowCookies && onAllowCookies();
        bloomreachCms.visitorId && persistBloomreachVisitorId(bloomreachCms.visitorId);
    }, [onAllowCookies, bloomreachCms.visitorId]);
    // TODO fix the any
    return (createElement(Fragment, null,
        preview && createElement(ManageContentButton, { content: content, preview: preview }),
        createElement(CookieNotification, { content: content, onAllowCookies: allowCookies })));
};
function persistBloomreachVisitorId(visitorId) {
    // the bloomreach API responds with a set-cookie header which expires in two years, so we'll copy that value
    Cookie.set('_visitor', visitorId, { expires: 365 * 2, path: '/' });
}
var CmsCookieNotification$1 = compose(withBloomreachCms)(CmsCookieNotification);

var CmsDocument = function (_a) {
    var content = _a.content;
    return content.content ? createElement(RichTextArea, { content: content.content.value }) : null;
};
var Document = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsDocument);

var CmsEmpty = function (_a) {
    var configuration = _a.configuration, preview = _a.preview;
    if (!preview) {
        return null;
    }
    return createElement("div", null,
        configuration.name,
        " component");
};
var Empty = compose$1(withBloomreachData, withEditableContent)(CmsEmpty);

var CmsFaqItem = withEditableContent(function (_a) {
    var content = _a.content, activeId = _a.activeId;
    var name = content.name, question = content.question, answer = content.answer;
    return createElement(FaqItem, { id: name, question: question, answer: answer.value, activeId: activeId });
});
var CmsFaq = function (_a) {
    var content = _a.content, hidden = _a.hidden, preview = _a.preview, pageModel = _a.pageModel;
    var name = content.name, title = content.title, _b = content.faqItems, faqItems = _b === void 0 ? [] : _b;
    // We don't have an abstracted way to handle nested $refs yet
    // TODO: check if this is a common pattern or this component is an exception
    var items = useMemo(function () {
        return faqItems.map(function (_a) {
            var $ref = _a.$ref;
            return getBloomreachContent($ref, pageModel);
        });
    }, [faqItems, pageModel]);
    if (hidden) {
        return null;
    }
    return (createElement(Faq$1, { name: name, title: title, ids: items.map(function (item) { return item.name; }) }, items.map(function (item) { return (createElement(CmsFaqItem, { key: item.id, content: item, preview: preview })); })));
};
var Faq = compose(withBreakpointVisibility, withBloomreachData, withAnchor)(CmsFaq);

var CmsFooterMenu = withEditableContent(function (_a) {
    var content = _a.content;
    return createElement(FooterLinks, { items: content });
});
var CmsFooter = function (_a) {
    var pageModel = _a.pageModel, preview = _a.preview, siteName = _a.siteName;
    var _b;
    var configuration = pageModel.page.components.find(function (c) { return c.name === 'footer'; });
    var menuConfiguration = configuration === null || configuration === void 0 ? void 0 : configuration.components.find(function (c) { return c.name === 'menu'; });
    var footerContent = configuration && useBloomreachData(configuration, pageModel);
    var menuContent = createMenu(menuConfiguration);
    var logo = {
        url: (_b = pageModel.page.models) === null || _b === void 0 ? void 0 : _b.logoAlternativeUrl,
        altText: siteName || 'logo',
    };
    if (!footerContent) {
        return null;
    }
    return (createElement(Fragment, null,
        preview && createElement(ManageContentButton, { content: footerContent.data.content, preview: preview }),
        createElement(Footer, __assign({}, footerContent.data.content, { logo: logo, siteName: siteName }),
            createElement(CmsFooterMenu, { preview: preview, content: menuContent }))));
};

var CmsHeader = function (_a) {
    var headerLogo = _a.headerLogo, headerLogoMobile = _a.headerLogoMobile, headerMenuItems = _a.headerMenuItems, navMenuItems = _a.navMenuItems, appointmentMenuItems = _a.appointmentMenuItems, headerMenuModel = _a.headerMenuModel, navMenuModel = _a.navMenuModel, appointmentMenuModel = _a.appointmentMenuModel, pageRoutes = _a.pageRoutes, availableLocales = _a.availableLocales, countrySwitcherOptions = _a.countrySwitcherOptions, myAccountButton = _a.myAccountButton, preview = _a.preview, isSolaris = _a.isSolaris, isSearchEnabledOnSmallScreens = _a.isSearchEnabledOnSmallScreens, renderCartButton = _a.renderCartButton, isSearchEnabled = _a.isSearchEnabled, isMultilingualEnabled = _a.isMultilingualEnabled, onSubmitSearch = _a.onSubmitSearch, routeFormatters = _a.routeFormatters, staticsUrl = _a.staticsUrl, algoliaHeaderConfig = _a.algoliaHeaderConfig, getProductImageUrl = _a.getProductImageUrl, _b = _a.renderSiteNav, renderSiteNav = _b === void 0 ? true : _b, cookieBar = _a.cookieBar, siteName = _a.siteName;
    return (createElement(Header, __assign({ logo: headerLogo, logoMobile: headerLogoMobile, pageRoutes: pageRoutes, menuItems: headerMenuItems, myAccountButton: myAccountButton, renderCartButton: renderCartButton, isSearchEnabled: isSearchEnabled(), isSearchEnabledOnSmallScreens: isSearchEnabledOnSmallScreens, isMultilingualEnabled: isMultilingualEnabled, availableLocales: availableLocales, staticsUrl: staticsUrl, algoliaHeaderConfig: algoliaHeaderConfig, onSubmit: onSubmitSearch, getProductImageUrl: getProductImageUrl }, routeFormatters, { preview: preview, countrySwitcherOptions: countrySwitcherOptions, renderSiteNav: renderSiteNav, cookieBar: cookieBar, siteName: siteName }),
        preview && (createElement(ManageContentButton, { styles: { left: '-600px' }, content: headerMenuModel, preview: preview })),
        preview && (createElement(ManageContentButton, { styles: { left: '-100px', top: '75px' }, content: appointmentMenuModel, preview: preview })),
        preview && (createElement(ManageContentButton, { styles: { top: '-65px' }, content: navMenuModel, preview: preview })),
        renderSiteNav && (createElement(SiteNav, { menuItems: navMenuItems, appointmentItems: appointmentMenuItems, isSolaris: isSolaris, routes: { cart: pageRoutes.cart, stores: pageRoutes.stores }, countrySwitcherOptions: countrySwitcherOptions }))));
};

function isMoreSpecific(nextLink, prevLink) {
    if (nextLink === void 0) { nextLink = ''; }
    if (prevLink === void 0) { prevLink = ''; }
    var isEqual = (nextLink.match(/\//g) || []).length === (prevLink.match(/\//g) || []).length;
    if (isEqual) {
        return nextLink.length > prevLink.length;
    }
    else {
        return (nextLink.match(/\//g) || []).length > (prevLink.match(/\//g) || []).length;
    }
}
function checkIfActive(currentPath, itemPath) {
    if (currentPath === void 0) { currentPath = ''; }
    if (itemPath === void 0) { itemPath = ''; }
    // root c.q. home
    if (currentPath === '/' && itemPath === '/') {
        return true;
    }
    else {
        return currentPath.startsWith(itemPath);
    }
}
function convertToBloomreachMenuItem(items) {
    var getHref = function (item) { return (item.link ? item.link.href : ''); };
    return items.map(function (item) { return (__assign(__assign({}, item), { name: item.label, _links: { site: { href: getHref(item), type: 'external' } }, childMenuItems: [] })); });
}
var createMyAccountMobileMenuStructure = function (intl, formattedRoutes, logout, isLoggedIn) {
    var submenu = [
        {
            name: '',
            _links: {},
            childMenuItems: formattedRoutes
                ? convertToBloomreachMenuItem(Utils.getMyAccountMenuItems(logout, formattedRoutes, intl, isLoggedIn))
                : [],
        },
    ];
    return {
        name: intl.getLabel('account.menu.myAccount'),
        parameters: {
            menuKey: 'my-account',
        },
        childMenuItems: submenu,
        _links: {
            site: undefined,
        },
    };
};
var createLocaleSwitcherMenuStructure = function (availableLocales, intl) {
    var localeSwitcherMenuLabel = getLocaleSwitcherMenuLabel(intl.language);
    var localeMenuItems = getLocaleSwitcherData(availableLocales, false);
    var activeLocale = availableLocales.find(function (item) { return item.locale.replace('_', '-') === intl.locale; });
    return {
        label: localeSwitcherMenuLabel,
        parameters: { menuKey: 'locale-switcher' },
        childMenuItems: [
            {
                label: activeLocale ? activeLocale.chooseLanguage : localeSwitcherMenuLabel,
                childMenuItems: localeMenuItems,
            },
        ],
    };
};
var getCountrySwitcherUrls = function (pageModel) {
    var _a, _b;
    var countrySwitcherRef = (_b = (_a = pageModel.page.models) === null || _a === void 0 ? void 0 : _a.countrySwitcher) === null || _b === void 0 ? void 0 : _b.$ref;
    if (!countrySwitcherRef) {
        return undefined;
    }
    var content = getContentByRef(countrySwitcherRef, pageModel);
    if (!content.imageLinkList) {
        return undefined;
    }
    return content.imageLinkList.map(function (list) {
        return {
            image: list.image && list.image.url,
            label: list.link.label,
            openInNewWindow: list.link.openInNewWindow || false,
            url: list.link.url || '',
        };
    });
};
var withMyAccountMenuItems = function (navMenuData, intl, formattedRoutes, logout, isUserLoggedIn) {
    var myAccountMenuItems = createMyAccountMobileMenuStructure(intl, formattedRoutes, logout, isUserLoggedIn);
    return __assign(__assign({}, navMenuData), { models: __assign(__assign({}, navMenuData.models), { menu: __assign(__assign({}, navMenuData.models.menu), { siteMenuItems: __spread(navMenuData.models.menu.siteMenuItems, [myAccountMenuItems]) }) }) });
};
var CmsHeader$1 = function (_a) {
    var asPath = _a.asPath, intl = _a.intl, pageModel = _a.pageModel, includeProductUrlSku = _a.includeProductUrlSku, auth = _a.auth, siteName = _a.siteName, isMyAccountEnabled = _a.isMyAccountEnabled, _b = _a.isMultilingualEnabled, isMultilingualEnabled = _b === void 0 ? function () { return false; } : _b, _c = _a.isSearchEnabled, isSearchEnabled = _c === void 0 ? function () { return false; } : _c, formattedRoutes = _a.formattedRoutes, logout = _a.logout, recoverSession = _a.recoverSession, rest = __rest(_a, ["asPath", "intl", "pageModel", "includeProductUrlSku", "auth", "siteName", "isMyAccountEnabled", "isMultilingualEnabled", "isSearchEnabled", "formattedRoutes", "logout", "recoverSession"]);
    return (createElement(RuntimeContext.Consumer, null, function (context) { return (createElement(CmsDynamicRoutes, { pageModel: pageModel, includeProductUrlSku: includeProductUrlSku }, function (routeFormatters) {
        var _a, _b, _c, _d, _e, _f;
        var configuration = getConfigurationForPath('header', pageModel);
        var pageRoutes = (_a = pageModel.page.models) === null || _a === void 0 ? void 0 : _a.routes;
        var availableLocales = (_b = pageModel.page.models) === null || _b === void 0 ? void 0 : _b.localeOptions;
        var countrySwitcherOptions = getCountrySwitcherUrls(pageModel);
        var _g = __read(useState(false), 2), mounted = _g[0], setMounted = _g[1];
        var authRef = useRef(auth);
        if (!((_c = configuration === null || configuration === void 0 ? void 0 : configuration.components) === null || _c === void 0 ? void 0 : _c.length)) {
            console.error('No configuration or components found for Header in CMS model!');
            return createElement(Fragment, null);
        }
        var headerMenuData = configuration.components.find(function (comp) { return comp.name === 'top-menu'; });
        var navMenuData = configuration.components.find(function (comp) { return comp.name === 'main-menu'; });
        var appointmentMenuData = configuration.components.find(function (comp) { return comp.name === 'appointment-menu'; });
        var headerMenuItems = createMenu(headerMenuData);
        var appointmentMenuItems = createMenu(appointmentMenuData);
        var headerLogo = useRef({
            url: (_d = pageModel.page.models) === null || _d === void 0 ? void 0 : _d.logoUrl,
            altText: siteName || 'logo',
        });
        var headerLogoMobile = useRef(__assign(__assign({}, headerLogo.current), { url: (_e = pageModel.page.models) === null || _e === void 0 ? void 0 : _e.logoMobileUrl }));
        // Get all navigation content
        var withMyAccount = isMyAccountEnabled();
        var withMultilingual = isMultilingualEnabled();
        var isUserLoggedIn = State.getLoggedInState(auth) === 'logged-in';
        // Let analytics know if user is logged in
        setUserObject(isUserLoggedIn);
        var myAccountButton = useMemo(function () {
            if (!withMyAccount || !formattedRoutes) {
                return null;
            }
            var menuItems = Utils.getMyAccountMenuItems(logout, formattedRoutes, intl, isUserLoggedIn);
            var items = convertToBloomreachMenuItem(menuItems);
            return createElement(MyAccountMenu, { menuItems: mapToMenu(items) });
        }, [withMyAccount, formattedRoutes, logout, intl, isUserLoggedIn]);
        var navMenuItems = useMemo(function () {
            var data = withMyAccount
                ? withMyAccountMenuItems(navMenuData, intl, formattedRoutes, logout, isUserLoggedIn)
                : navMenuData;
            var menuItems = Utils.stripMenuItemsIcon(createMenu(data));
            var result = withMultilingual
                ? __spread(menuItems, [createLocaleSwitcherMenuStructure(availableLocales, intl)]) : menuItems;
            var currentPath = asPath.split('?')[0];
            var previewLinkPrefix = "/site/_cmsinternal" + (process.env.BLOOMREACH_CHANNEL_PATH ? '/' + process.env.BLOOMREACH_CHANNEL_PATH : '');
            // Check if a sitenav item's url corresponds with the current url path
            var activeItems = result.filter(function (menuItem) { var _a; return checkIfActive(currentPath, (((_a = menuItem.link) === null || _a === void 0 ? void 0 : _a.href) || '').replace(previewLinkPrefix, '')); });
            var active = activeItems
                .sort(function (a, b) { var _a, _b; return (isMoreSpecific((_a = a.link) === null || _a === void 0 ? void 0 : _a.href, (_b = b.link) === null || _b === void 0 ? void 0 : _b.href) ? -1 : 1); })
                .shift();
            if (active) {
                active.link = active.link || {};
                active.link.active = true;
            }
            return result;
        }, [asPath, formattedRoutes, logout, intl, isUserLoggedIn, withMyAccount, navMenuData]);
        useEffect(function () {
            // Runs on mount and updates
            if ((!mounted || State.isUninitialized(authRef.current)) && State.isInitialized(auth)) {
                recoverSession();
            }
            setMounted(true);
            authRef.current = auth;
        });
        var headerMenuModel = headerMenuData.models.menu;
        var navMenuModel = navMenuData.models.menu;
        var appointmentMenuModel = appointmentMenuData.models.menu;
        return (createElement(CmsHeader, __assign({}, rest, { availableLocales: availableLocales, countrySwitcherOptions: countrySwitcherOptions, headerLogo: headerLogo.current, headerLogoMobile: headerLogoMobile.current, headerMenuItems: headerMenuItems, navMenuItems: navMenuItems, appointmentMenuItems: appointmentMenuItems, headerMenuModel: headerMenuModel, navMenuModel: navMenuModel, appointmentMenuModel: appointmentMenuModel, myAccountButton: myAccountButton, pageRoutes: pageRoutes, isMultilingualEnabled: isMultilingualEnabled(), isSearchEnabled: isSearchEnabled, routeFormatters: routeFormatters, staticsUrl: ((_f = context === null || context === void 0 ? void 0 : context.grandvision) === null || _f === void 0 ? void 0 : _f.staticsUrl) || '', algoliaHeaderConfig: context.algolia })));
    })); }));
};
var mapStateToProps = function (state) { return ({
    auth: Selectors.getAuth(state),
    formattedRoutes: Selectors.getFormattedRoutes(state),
}); };
var mapDispatchToProps = {
    logout: Actions.LogoutActions.logOut,
    recoverSession: Actions.LoginActions.recoverSession,
};
var CmsHeader$2 = connect(mapStateToProps, mapDispatchToProps)(withIntl(CmsHeader$1));

var variantMap = {
    h1: 'large',
    h2: 'medium',
    h3: 'small',
    h4: 'smallest',
    h5: 'subheading1',
    h6: 'subheading2',
};
var CmsHeading = function (_a) {
    var meta = _a.meta;
    var title = meta.title, type = meta.type, alignment = meta.alignment;
    return (createElement(Heading$1, { className: "heading heading--" + alignment, variant: variantMap[type], align: alignment }, title));
};
var Heading = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsHeading);

var CmsIconList = function (_a) {
    var content = _a.content, hidden = _a.hidden, theme = _a.theme;
    var iconLinkCompoundList = content.iconLinkCompoundList, title = content.title;
    var items = useMemo(function () {
        return iconLinkCompoundList
            ? iconLinkCompoundList.map(function (item) { return ({
                icon: item.icon,
                label: item.link.label,
                url: item.link.url,
            }); })
            : [];
    }, [iconLinkCompoundList]);
    if (hidden) {
        return null;
    }
    return createElement(IconList$1, { items: items, title: title, theme: theme });
};
var IconList = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsIconList);

var CmsNotificationBar = function (_a) {
    var content = _a.content, hidden = _a.hidden, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b;
    var title = content.title, description = content.description, links = content.links;
    var link = useMemo(function () {
        var _a = __read(parseBloomreachLinks(links), 1), link = _a[0];
        return link && { url: link.url, label: link.label || '', target: link.target };
    }, [links]);
    if (hidden || (!title && !description)) {
        return null;
    }
    return createElement(NotificationBar$1, { title: title, description: description, theme: theme, link: link });
};
var NotificationBar = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsNotificationBar);

var CmsOlapic = function (_a) {
    var intl = _a.intl, meta = _a.meta;
    var _b = React__default.useContext(RuntimeContext).olapic, apiKey = _b.apiKey, url = _b.url;
    return (React__default.createElement(Olapic$1, { apiKey: apiKey, instance: meta.instance, locale: intl.locale.replace('_', '-'), olapic: meta.olapic, src: url, tags: meta.tags }));
};
var Olapic = compose(withIntl, withBreakpointVisibility, withAnchor, withBloomreachData)(CmsOlapic);

var CmsPolicyBar = function (_a) {
    var content = _a.content, hidden = _a.hidden, _b = _a.theme, theme = _b === void 0 ? 'optical' : _b;
    var _c;
    if (hidden || !((_c = content === null || content === void 0 ? void 0 : content.policyItems) === null || _c === void 0 ? void 0 : _c.length)) {
        return null;
    }
    return createElement(UspGroup, __assign({}, content, { theme: theme }));
};
var PolicyBar = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsPolicyBar);

function getCategoryRoute(pageModel) {
    var _a, _b;
    var productRouteRef = (_a = pageModel.page.models) === null || _a === void 0 ? void 0 : _a.productRoutes.$ref;
    var productType = (_b = pageModel.page.models) === null || _b === void 0 ? void 0 : _b.productType;
    return getContentByRef(productRouteRef, pageModel).productRoutes.find(function (productRoute) { return productRoute.productType === productType; });
}
function getProductType(product) {
    var _a;
    return (_a = product.productType.obj) === null || _a === void 0 ? void 0 : _a.name;
}
function getMainMenuItems(pageModel) {
    var _a, _b, _c;
    var components = (_a = pageModel.page) === null || _a === void 0 ? void 0 : _a.components;
    var headerComponents = (_b = components === null || components === void 0 ? void 0 : components.find(function (component) { return component.name === 'header'; })) === null || _b === void 0 ? void 0 : _b.components;
    var mainMenuComponent = headerComponents === null || headerComponents === void 0 ? void 0 : headerComponents.find(function (component) { return component.name === 'main-menu'; });
    return (_c = mainMenuComponent === null || mainMenuComponent === void 0 ? void 0 : mainMenuComponent.models) === null || _c === void 0 ? void 0 : _c.menu.siteMenuItems;
}
function createCategoryBreadcrumb(pageModel, categoryRoute) {
    var mainMenuItems = getMainMenuItems(pageModel);
    var categoryMainMenu = mainMenuItems === null || mainMenuItems === void 0 ? void 0 : mainMenuItems.find(function (menuItem) { var _a; return ((_a = menuItem._links.site) === null || _a === void 0 ? void 0 : _a.href) === categoryRoute.route; });
    return categoryMainMenu ? { id: 1, name: categoryMainMenu.name, url: categoryRoute.route } : null;
}
function createSubCategoryBreadcrumb(categoryRoute, product, productType, locale) {
    var _a, _b;
    var brand = ((_b = (_a = product.masterVariant.attributes) === null || _a === void 0 ? void 0 : _a.find(function (attr) { return attr.name === 'brand'; })) === null || _b === void 0 ? void 0 : _b.value) || '';
    if (productType && CommerceToolsApi.isLenses(productType)) {
        var replacementFrequency = getLocalizedAttrValue(product.masterVariant, 'replacementFrequency', locale) || '';
        return replacementFrequency
            ? {
                id: 2,
                name: replacementFrequency,
                url: categoryRoute.route + ("?replacementFrequency=" + replacementFrequency),
            }
            : null;
    }
    return brand
        ? { id: 2, name: brand, url: categoryRoute.route + ("?brand=" + encodeURIComponent(brand)) }
        : null;
}
function createProductBreadcrumb(categoryBreadcrumb, product, productType, sku, locale) {
    var activeVariant = Helpers.getActiveVariant(product, sku);
    if (productType &&
        (CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType))) {
        var productName = product && getLocalizedValue(product.name, locale);
        return productName && sku && categoryBreadcrumb ? { id: 3, name: productName } : null;
    }
    return activeVariant.name && sku && categoryBreadcrumb
        ? { id: 3, name: activeVariant.name }
        : null;
}
var CmsProductBreadcrumbs = function (_a) {
    var pageModel = _a.pageModel, product = _a.product, sku = _a.sku;
    var locale = useIntl().locale;
    var categoryRoute = getCategoryRoute(pageModel);
    var productType = getProductType(product);
    var categoryBreadcrumb = createCategoryBreadcrumb(pageModel, categoryRoute);
    var subCategoryBreadcrumb = createSubCategoryBreadcrumb(categoryRoute, product, productType, locale);
    var productBreadcrumb = createProductBreadcrumb(categoryBreadcrumb, product, productType, sku, locale);
    var breadcrumbs = [categoryBreadcrumb, subCategoryBreadcrumb, productBreadcrumb].filter(function (breadcrumb) { return breadcrumb !== null; });
    return (createElement("div", { className: "breadcrumbs-wrapper" },
        createElement(Container, null,
            createElement(Breadcrumbs, { pages: breadcrumbs }))));
};

function getPromotion(_a) {
    var preview = _a.preview, pageModel = _a.pageModel, promotion = _a.promotion;
    var content = getContentByRef(promotion === null || promotion === void 0 ? void 0 : promotion.$ref, pageModel);
    if (!content) {
        return undefined;
    }
    return __assign(__assign({}, content), { links: content.links[0], manageContentButton: preview ? (React__default.createElement(ManageContentButton, { content: promotion, preview: preview })) : undefined });
}
var ProductCatalog = function (_a) {
    var pageModel = _a.pageModel, content = _a.content, preview = _a.preview;
    var isEnabled = useAlgoliaConfig().isEnabled;
    var intl = useIntl();
    if (!content) {
        console.error('No content object supplied for ProductCatalog in CMS model!');
        return null;
    }
    if (!isEnabled) {
        console.error("You're trying to render the <ProductCatalog />, but the `AlgoliaConfig` is not configured properly.");
        return null;
    }
    var seoData = getPageSeo(pageModel);
    var amountOfHitsLabel = intl.getLabel('search.results.amount.title');
    var promotionSmall = getPromotion({ preview: preview, pageModel: pageModel, promotion: content.smallPromotion });
    var promotionBig = getPromotion({ preview: preview, pageModel: pageModel, promotion: content.bigPromotion });
    var manageContentButton = preview ? (React__default.createElement(CmsEditButton, { configuration: content, preview: preview })) : null;
    return (React__default.createElement(RuntimeContext.Consumer, null, function (publicRuntimeConfig) { return (React__default.createElement(CmsDynamicRoutes, { pageModel: pageModel, includeProductUrlSku: publicRuntimeConfig.includeProductUrlSku }, function (_a) {
        var formatProductUrl = _a.formatProductUrl;
        return (React__default.createElement(AlgoliaSearch, null, function (stateResults) {
            var _a;
            return (React__default.createElement(React__default.Fragment, null,
                preview && manageContentButton,
                React__default.createElement(SearchPageHeader, { pageTitle: content.title, hitTitle: (stateResults === null || stateResults === void 0 ? void 0 : stateResults.searchResults.nbHits) + " " + amountOfHitsLabel }),
                React__default.createElement(ConnectedProductListing, { formatProductUrl: formatProductUrl, staticsUrl: ((_a = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.grandvision) === null || _a === void 0 ? void 0 : _a.staticsUrl) || '', promotionSmall: promotionSmall, promotionBig: promotionBig, getProductImageUrls: publicRuntimeConfig.getProductImageUrls }),
                React__default.createElement(ScrollUpButton, null),
                seoData && (React__default.createElement(WebPage, { url: seoData.canonicalUrl, pageType: "ProductListing", name: seoData.title, description: seoData.description }))));
        }));
    })); }));
};
var ProductCatalog$1 = compose(withAnchor, withBreakpointVisibility, withBloomreachData)(ProductCatalog);

var CmsPromotion = function (_a) {
    var content = _a.content, pageModel = _a.pageModel;
    var products = content.products, supertitle = content.supertitle, title = content.title, promotionLabel = content.promotionLabel;
    return (createElement(RuntimeContext.Consumer, null, function (publicRuntimeConfig) { return (createElement(CmsDynamicRoutes, { pageModel: pageModel }, function (_a) {
        var formatProductUrl = _a.formatProductUrl;
        return (createElement(ProductPromotions, { products: products, promotionLabel: promotionLabel, supertitle: supertitle, title: title, staticsUrl: publicRuntimeConfig.grandvision.staticsUrl, formatProductUrl: formatProductUrl, getProductImageUrls: publicRuntimeConfig.getProductImageUrls }));
    })); }));
};
var Promotion = compose(withBreakpointVisibility, withAnchor, withBloomreachData)(CmsPromotion);

var CmsRecentlyViewedProducts = function (_a) {
    var pageModel = _a.pageModel;
    var publicRuntimeConfig = useContext(RuntimeContext);
    return (createElement(CmsDynamicRoutes, { pageModel: pageModel }, function (_a) {
        var formatProductUrl = _a.formatProductUrl;
        var _b;
        return (createElement(RecentlyViewedProducts$1, { staticsUrl: ((_b = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.grandvision) === null || _b === void 0 ? void 0 : _b.staticsUrl) || '', formatProductUrl: formatProductUrl }));
    }));
};
var RecentlyViewedProducts = compose(withBreakpointVisibility, withAnchor)(CmsRecentlyViewedProducts);

var CmsRichText = function (_a) {
    var content = _a.content, meta = _a.meta, preview = _a.preview;
    var _b, _c;
    var template = meta.template;
    switch (template) {
        case 'default':
            return content.content ? createElement(RichTextArea, { content: (_b = content.content) === null || _b === void 0 ? void 0 : _b.value }) : null;
        // Modal template is only added to be able to retrieve the content from the pageModel.
        // Current usecase is the prescription modal in the ContactLensesConfigurator.
        case 'modal':
            return preview && content.content ? createElement(RichTextArea, { content: (_c = content.content) === null || _c === void 0 ? void 0 : _c.value }) : null;
        default:
            return createElement("h5", null,
                "RichText component of type ",
                template,
                " not defined in RichTextCollection");
    }
};
var RichText = compose(withBreakpointVisibility, withAnchor, withBloomreachData, withEditableContent)(CmsRichText);

function rewriteCanonical(canonicalUrl, selfUrl) {
    // Strip scheme and host from url and save just the pathname parts
    var _a = __read(canonicalUrl.split('/')), path = _a.slice(3);
    return selfUrl + "/" + path.join('/');
}
function createHreflangLink(hreflang, selfUrl) {
    var absoluteUrlPattern = /^https?:\/\/|^\/\//i;
    var url = absoluteUrlPattern.test(hreflang.url)
        ? hreflang.url
        : "" + (selfUrl || '') + hreflang.url;
    var locale = hreflang.locale.replace('_', '-').toLowerCase();
    return { url: url, locale: locale };
}
var CmsHeadTags = function (_a) {
    var title = _a.title, description = _a.description, ogUrl = _a.ogUrl, ogImage = _a.ogImage, hreflangs = _a.hreflangs, noIndex = _a.noIndex, noFollow = _a.noFollow, children = _a.children;
    return (createElement(RuntimeContext.Consumer, null, function (_a) {
        var headComponent = _a.headComponent, selfUrl = _a.selfUrl, _b = _a.site, site = _b === void 0 ? {} : _b;
        var siteName = site.name || '';
        var props = {
            title: title ? title + " | " + siteName : siteName,
            description: description || site.description || '',
            ogImage: ogImage || site.ogImage || '',
            ogUrl: rewriteCanonical(ogUrl || site.url || '', selfUrl),
            hreflangs: Array.isArray(hreflangs) && hreflangs.length > 1
                ? hreflangs.map(function (entry) { return createHreflangLink(entry, selfUrl); })
                : [],
            headComponent: headComponent,
            noIndex: noIndex,
            noFollow: noFollow,
            children: children,
        };
        return createElement(HeadTags, __assign({}, props));
    }));
};

var CmsSeo = function (_a) {
    var pageModel = _a.pageModel, preview = _a.preview;
    var _b;
    var seoData = getPageSeo(pageModel);
    if (preview) {
        return React__default.createElement("div", null, "SEO configuration");
    }
    return (React__default.createElement(CmsHeadTags, __assign({}, seoData, { ogUrl: seoData.canonicalUrl, noFollow: seoData.nofollow, noIndex: seoData.noindex, ogImage: ((_b = seoData.image) === null || _b === void 0 ? void 0 : _b.url) || '' })));
};

var defaultComponentDefinitions = {
    Accordion: defineComponent(CmsAccordion$1),
    Article: defineComponent(Article),
    Banner: defineComponent(CmsBanner$1),
    'Banner collection': defineComponent(CmsBannerCollection$1),
    'Blog Collection': defineComponent(BlogCollection),
    'Blog Overview': defineComponent(BlogOverview),
    'Brand collection': defineComponent(BrandCollection),
    'Brand List': defineComponent(BrandList),
    Carousel: defineComponent(CmsCarousel$1),
    Document: defineComponent(Document),
    FAQ: defineComponent(Faq),
    Heading: defineComponent(Heading),
    'Icon-Link List': defineComponent(IconList),
    IFrame: defineComponent(CmsIframe$1),
    'Notification bar': defineComponent(NotificationBar),
    'Olapic Widget': defineComponent(Olapic),
    Page: defineComponent(Empty),
    'Policy bar': defineComponent(PolicyBar),
    'Product catalog v2': defineComponent(ProductCatalog$1),
    Promotion: defineComponent(Promotion),
    'Rich Text': defineComponent(RichText),
    Seo: defineComponent(CmsSeo),
    Translation: defineComponent(CmsAccordion$1),
    Video: defineComponent(CmsVideo$1),
    Widget: defineComponent(CmsWidget$1),
    'Recently viewed products': defineComponent(RecentlyViewedProducts),
};
function defineComponent(component, wrapInContentComponent) {
    if (wrapInContentComponent === void 0) { wrapInContentComponent = false; }
    return { component: component, wrapInContentComponent: wrapInContentComponent };
}
function extendComponentDefinitions(definitionsToAdd) {
    return __assign(__assign({}, defaultComponentDefinitions), definitionsToAdd);
}

/* This is in a separate module from BloomreachContext itself to avoid a
 * circular dependency between ../component-definitons and ../containers.
 *
 * Do not re-export this from ./index
 */
function BloomreachProvider(_a) {
    var value = _a.value, children = _a.children;
    var cmsUrls = value.cmsUrls, componentDefinitions = value.componentDefinitions, pageModel = value.pageModel, preview = value.preview, request = value.request, visitorId = value.visitorId;
    var mergedValue = useMemo(function () { return ({
        cmsUrls: cmsUrls || initialValue.cmsUrls,
        componentDefinitions: componentDefinitions || defaultComponentDefinitions,
        pageModel: pageModel || initialValue.pageModel,
        preview: preview || initialValue.preview,
        request: request || initialValue.request,
        visitorId: visitorId,
    }); }, [cmsUrls, componentDefinitions, pageModel, preview, request, visitorId]);
    return createElement(BloomreachContext.Provider, { value: mergedValue, children: children });
}

var defaultLayout = {
    header: true,
    footer: true,
    navigation: true,
};
var CmsPageLayout = function (_a) {
    var children = _a.children, asPath = _a.asPath, siteName = _a.siteName, featureToggles = _a.featureToggles, _b = _a.layout, layout = _b === void 0 ? defaultLayout : _b, _c = _a.renderCartButton, renderCartButton = _c === void 0 ? defaultRenderCartButton : _c, getProductImageUrl = _a.getProductImageUrl, _d = _a.includeProductUrlSku, includeProductUrlSku = _d === void 0 ? true : _d, _e = _a.isSolaris, isSolaris = _e === void 0 ? false : _e;
    var _f = useBloomreach(), pageModel = _f.pageModel, preview = _f.preview;
    var algolia = useContext(RuntimeContext).algolia;
    // TODO: We should handle this in the header so we can bind this to submit event
    var handleSearch = useCallback(function (query, type) {
        if (!algolia) {
            return;
        }
        var indexes = algolia.indexes, productIndex = algolia.productIndex;
        var storeIndex = indexes === null || indexes === void 0 ? void 0 : indexes.find(function (index) { return index.type === 'stores'; });
        switch (type) {
            case 'products':
                window.location.assign("" + productIndex.targetPath + encodeURIComponent(query));
                break;
            case 'stores':
                storeIndex &&
                    window.location.assign("" + storeIndex.targetPath + encodeURIComponent(query));
                break;
            default:
                console.warn("Trying to perform search action for unknown Algolia index type: " + type);
        }
    }, [algolia]);
    var header = layout.header ? (createElement(CmsHeader$2, __assign({ pageModel: pageModel, preview: preview, asPath: asPath, siteName: siteName, isSolaris: isSolaris, onSubmitSearch: handleSearch, renderSiteNav: layout.navigation, renderCartButton: renderCartButton, includeProductUrlSku: includeProductUrlSku, getProductImageUrl: getProductImageUrl }, featureToggles))) : null;
    var footer = layout.footer ? (createElement(CmsFooter, { pageModel: pageModel, preview: preview, siteName: siteName })) : null;
    var cookieBar = createElement(CmsCookieNotification$1, { pageModel: pageModel, preview: preview });
    return (createElement(PageLayout, { cookieBar: cookieBar, header: header, footer: footer, isSolaris: isSolaris, hasSiteNav: layout.navigation }, children));
};
var defaultRenderCartButton = function (item) {
    return (createElement(CartButton, { key: item.label, href: item.link && item.link.href, label: item.label, className: "header-menu__icon" }));
};

var CmsContentLayout = function (_a) {
    var content = _a.content, pageModel = _a.pageModel, customComponents = _a.customComponents, preview = _a.preview, pageName = _a.pageName;
    var contentBlocks = content.contentBlocks, coverImage = content.coverImage, displayName = content.displayName, name = content.name, summary = content.summary, title = content.title, url = content.url;
    var image = parseBloomreachImage(coverImage);
    var isBrandPage = pageName === 'brand-detail';
    return (createElement("div", { className: classnames('content-layout', {
            'content-layout--brand': isBrandPage,
        }) },
        createElement(Container, { className: "content-layout__breadcrumbs" },
            createElement(CmsContentBreadcrumbs, { displayName: displayName, name: name, url: url })),
        image && createElement(Banner, { useContainer: true, image: image.original, mobileImage: image.mobile }),
        title && (createElement(Heading$1, { variant: "large", className: "content-layout__title", align: isBrandPage ? 'center' : 'left' }, title)),
        summary && (createElement("div", { className: "content-layout__summary rich-text-area" },
            createElement(Text, { align: isBrandPage ? 'center' : 'left' }, summary))),
        createElement("article", { className: "content", id: "content-start" }, contentBlocks.length > 0 && (createElement(CmsContentBlocks, { contentBlocks: contentBlocks, pageModel: pageModel, preview: preview, customComponents: customComponents })))));
};
var CmsContentLayout$1 = withEditableContent(CmsContentLayout);

var CmsBlogLayout = function (_a) {
    var content = _a.content, pageModel = _a.pageModel, preview = _a.preview;
    var title = content.title, summary = content.summary, coverImage = content.coverImage, publishDate = content.publishDate, readingTime = content.readingTime, contentBlocks = content.contentBlocks;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var image = parseBloomreachImage(coverImage);
    return (createElement("div", { className: "blog-layout" },
        image && (createElement(BlogDetailHeader, { title: title, image: image.original, mobileImage: image.mobile, scrollTo: "blog-content-start" })),
        summary && (createElement(BlogIntro, { locale: locale, summary: summary, publishDate: publishDate, readingTime: readingTime, minutesLabel: getLabel('blog.minutesToRead') })),
        createElement("article", { className: "blog-content", id: "blog-content-start" }, contentBlocks.length > 0 && (createElement(CmsContentBlocks, { contentBlocks: content.contentBlocks, pageModel: pageModel, preview: preview })))));
};
var CmsBlogLayout$1 = withEditableContent(CmsBlogLayout);

var isBlogArticle = function (content) {
    return content.type === 'blogArticle';
};
var CmsContentPage = function (props) {
    var _a, _b;
    var _c = useBloomreach(), pageModel = _c.pageModel, preview = _c.preview;
    var configuration = getComponentByPath('main/content', pageModel);
    var content = getContentByRef((_b = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.models) === null || _a === void 0 ? void 0 : _a.document) === null || _b === void 0 ? void 0 : _b.$ref, pageModel);
    var seo = getPageSeo(pageModel);
    return (createElement(Fragment, null,
        createElement(CmsSeo, { configuration: {}, pageModel: pageModel, preview: preview }),
        createElement(CmsPageLayout, __assign({}, props), content && (createElement(Fragment, null, isBlogArticle(content) ? (createElement(CmsBlogLayout$1, { content: content, pageModel: pageModel, preview: preview })) : (createElement(CmsContentLayout$1, { content: content, pageModel: pageModel, preview: preview }))))),
        seo && content && (createElement(WebPage, { pageType: "Information", url: seo.canonicalUrl, name: content.title, description: content.summary }))));
};

var CmsContainerPage = function (_a) {
    var children = _a.children;
    var _b = useBloomreach(), cmsUrls = _b.cmsUrls, componentDefinitions = _b.componentDefinitions, pageModel = _b.pageModel, preview = _b.preview, request = _b.request;
    return (createElement(CmsPage, { cmsUrls: cmsUrls, componentDefinitions: componentDefinitions, pageModel: pageModel, preview: preview, request: request, children: function () { return children; } }));
};



var bloomreach = /*#__PURE__*/Object.freeze({
    __proto__: null
});

export { CmsBlogLayout$1 as BlogLayout, bloomreach as BloomreachApi, BloomreachCmsContext, BloomreachCmsProvider, BloomreachProvider, BloomreachService, CmsAccordion$1 as CmsAccordion, Article as CmsArticle, CmsArticleCollection$1 as CmsArticleCollection, CmsBanner$1 as CmsBanner, CmsBannerCollection$1 as CmsBannerCollection, BlogCollection as CmsBlogCollection, CmsBlogLayout$1 as CmsBlogLayout, BlogOverview as CmsBlogOverview, BrandCollection as CmsBrandCollection, BrandList as CmsBrandList, CmsProductBreadcrumbs as CmsBreadcrumbs, CmsCarousel$1 as CmsCarousel, CmsComponentSlot, CmsContainerPage, CmsContentBlocks, CmsContentBreadcrumbs, CmsContentLayout$1 as CmsContentLayout, CmsContentPage, CmsCookieNotification$1 as CmsCookieNotification, CmsCustomPackage, Document as CmsDocument, CmsDynamicRoutes, Empty as CmsEmpty, Faq as CmsFaq, CmsFooter, CmsHeader$2 as CmsHeader, Heading as CmsHeading, IconList as CmsIconList, CmsIframe$1 as CmsIframe, CmsLinkList$1 as CmsLinkList, NotificationBar as CmsNotificationBar, Olapic as CmsOlapic, CmsPageLayout, PolicyBar as CmsPolicyBar, CmsProductBreadcrumbs, ProductCatalog$1 as CmsProductCatalog, Promotion as CmsPromotion, RecentlyViewedProducts as CmsRecentlyViewedProducts, RichText as CmsRichText, CmsSeo, CmsVideo$1 as CmsVideo, CmsWidget$1 as CmsWidget, CmsContentLayout$1 as ContentLayout, CmsCustomPackage as CustomPackage, CmsDynamicRoutes as DynamicRoutes, CmsHeadTags as HeadTags, ManageContentButton, RuntimeContext, TYPE_COMPONENT, TYPE_COMPONENT_CONTAINER, TYPE_COMPONENT_CONTAINER_ITEM, TYPE_LINK_EXTERNAL, TYPE_LINK_INTERNAL, TYPE_LINK_RESOURCE, TYPE_META_COMMENT, createCmsUrl, createMenu, createResourcesUrl, defaultComponentDefinitions, defineComponent, extendComponentDefinitions, flattenResources, getAlgoliaConfigFromBloomreach, getClientSession, getComponentByPath, getComponentsBy, getConfigurationForPath, getContentByRef, getModalContent, getNoAddOnsImage, getPageSeo, getProductTypeUsps, getServerSession, groupBrands, mapToMenu, parseBloomreachImage, parseBloomreachInputField, parseBloomreachLinks, useBloomreach, withBloomreachCms };
//# sourceMappingURL=index.es.js.map
